<template>
    <div class="wrapper" style="overflow: hidden; background-color: #0045c4; margin-bottom: 20px;">
        <div class="page-header page-header-small" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img1') + ')' }"></parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center mt-5" style="padding-top: 5px;">
                        <h2 class="title">{{mensaje('tit1')}}</h2><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-40%,-90%); line-height: normal;">contratar.json->mensajes:tit1</span>
                        <h4>{{mensaje('tit2')}}</h4><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-40%,-90%); line-height: normal;">contratar.json->mensajes:tit2</span>
                    <!-- Ensure this closing tag matches an opening tag -->
                        </div>
                </div>
            </div>
        </div>
        <div class="page-head2 page-header-mini steps-background" style="background-color: #0045c4;" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>

       
        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(300%,-600%); line-height: normal;">contratar.json->mensajes:img1</span>
        <div style="background-color: #0045c4;">

          <div class="row section" style="padding-top: 0px; padding-bottom: 0px !important;">
            <div class="col-sm-12 col-md-12 ml-auto mr-auto" style="margin-bottom: 10px;">
              <div class="steps-background" style="width: 100%;">
                <el-steps :active="activeStep" finish-status="success">
                  <el-step :title="mensaje('men121')" :description="mensaje('men122')" :icon="mensaje('men123')"></el-step>
                  <el-step :title="mensaje('men124')" :disabled="activeStep < 1" :description="mensaje('men125')" :icon="mensaje('men126')"></el-step>
                  <el-step :title="mensaje('men127')" :disabled="activeStep < 2" :description="mensaje('men128')" :icon="mensaje('men129')"></el-step>
                  <!-- Añade tantos pasos como necesites -->
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 30px; left: 17%;">contratar.json->mensajes:men121</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 55px; left: 17%;">contratar.json->mensajes:men122</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: -5px; left: 14%;">contratar.json->mensajes:men123</span>
                  
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 30px; left: 60%;">contratar.json->mensajes:men124</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 55px; left: 60%;">contratar.json->mensajes:men125</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: -5px; left: 57%;">contratar.json->mensajes:men126</span>
                  
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 30px; left: 88%;">contratar.json->mensajes:men127</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: 55px; left: 88%;">contratar.json->mensajes:men128</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="top: -5px; left: 88%;">contratar.json->mensajes:men129</span>
                </el-steps>

                <!--
                    ******************************************************************************************************************************
                      PÁGINA DE LOCALIZACION Y TIPO DE TRASTERO
                    ******************************************************************************************************************************
                -->

                  <h1 class="titulo"><b>CONTRATA TU TRASTERO EN MADRID DE FORMA ONLINE EN SOLO 3 PASOS</b></h1>

                  
                    <div class="step-container mt-4">
                      <div class="step">
                        <div class="step-number">1</div>
                        <div class="step-title">Elige Tu Centro</div>
                        <span>Elige la localidad que te</span>
                        <span>interesa, el tipo y tamaño que</span>
                        <span>necesitas</span>
                      </div>
                      
                      <div class="step">
                        <div class="step-number">2</div>
                        <div class="step-title">Rellena Tus Datos</div>
                        <span>Rellena con atención todos los</span> 
                        <span>datos del formulario de</span>
                        <span>contratación</span>
                      </div>
                      
                      <div class="step">
                        <div class="step-number">3</div>
                        <div class="step-title">Accede Al Pago OnLine</div>
                        <span>Pago Seguro Red Redys</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="activeStep === 0">

                  <!-- 1.- ELIGE TU CENTRO -->
                  <h4 class="text-left" style="font-weight: 600; margin-top: 1px; padding-left: 7vh;">{{mensaje('men103')}}</h4>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men103</span>
                  <div style="display:flex; justify-content: center;">
                  <div class="row" style="display: flex; flex-wrap: wrap;">
                  <div class="col-md-4 col-sm-12 col-xs-12 " style="display: flex;" v-for="(centro, index) in this.centros" :key="index">
                    <div class="map-card card" style="display: flex; justify-content: center;">
                      <img draggable="false" style="border-radius: 1.5em; width: 100%; height: 26rem;" :src="centro.img" :alt="centro.nombre">
                      <n-button class="btn btn-top" :class="{'btn-seleccionado': centrosel.nombre === centro.nombre}" @click.native="eligeCentro(centro)" style="font-size: 0.9rem;">{{centro.nombre}}</n-button>
                    </div>
                  </div>
                  </div>
                  </div>
                  
                  <hr>
                  
                  <!-- 2.- ELIGE EL TIPO DE ESPACIO -->
                  <h4 class="text-left" style="font-weight: 600; margin-top: 1px; padding-left: 7vh;">{{mensaje('men105')}}</h4>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men105</span>
                  <div class="row">
                    <div class="col-md-10 mr-auto ml-auto" style="padding-left: 20px;">
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-30%); line-height: normal;">contratar.json->tipoespacio[]:nombre</span>
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,60%); line-height: normal;">contratar.json->tipoespacio[]:label (número correlativo)</span>
                      <span style="padding-right: 30px;" v-for="(tipo, index) in this.tiposespacio" :key="index">
                        <el-radio v-model="tipoesp" :label="tipo.label" border @change="tipoespCambia">{{tipo.nombre}}</el-radio>
                      </span>
                      <img v-if="tipoesp>0" class="img" src="img/icon-accept.svg" style="width: 30px;margin-right: 7px; margin-left: 0px; margin-bottom: 0px;"/>
                    </div>
                  </div>
                  
                  <hr>
                  
                  <!-- 3.- ELIGE EL MODELO -->
                  <h4 class="text-left" style="font-weight: 600; margin-top: 1px; padding-left: 7vh;">{{mensaje('men106')}}</h4>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men106</span>

                  <div class="row card-container" style="display: flex; flex-wrap: wrap; justify-content: space-between;" v-if="centrosel && Object.keys(centrosel).length > 0 && tipoesp > 0"> 
                    <div class="col-xs-6 col-sm-4 col-md-4 card-wrapper" v-for="opcion in medidas" :key="opcion.ID" v-show="opcion.visible" style="display: flex; flex-direction: column; align-items: center;">
                      
                      <card type="blog" style="width:90%; display: flex; flex-direction: column; height: 100%;">
                        
                        <div class="card-content" style="flex-grow: 1; display: flex; flex-direction: column;">
                          <div class="card-title text-center" v-if="showimg=true">
                            <img 
                              :src="opcion.RUT_WEB" 
                              @load="onLoaded(opcion)" 
                              style="height:200px; object-fit: contain;" 
                              slot="image" 
                              class="img rounded">
                          </div>
                          <h6 class="card-subtitle mb-2 text-muted">{{opcion.NAME}}</h6>
                          <div>{{opcion.REF_VAL}}</div>
                          <div>{{opcion.ESP_PAR}}</div>
                          <div>{{opcion.TAM}} {{opcion.VOL}}</div>
                          <!-- Aquí puedes agregar un margen automático para asegurar que el contenido que sigue (los botones) se empuje al fondo -->
                        </div>
                        
                        <!-- Este contenedor para los botones asegura que estén al final de la card -->
                        <div style="margin-top: auto; width: 110%;">
                          <n-button class="btn btn-bot" v-if="!tamelegido" @click.native="eligetam(opcion.ID)">
                            <b>{{mensaje('men25')}}</b>
                          </n-button>
                          <n-button class="btn btn-bot" v-if="tamelegido" @click.native="volver()">
                            <b>{{mensaje('men28')}}</b>
                          </n-button>
                          <img 
                            v-if="tamelegido" 
                            class="img icono-aceptado2" 
                            src="img/icon-accept.svg" 
                            style="width: 30px; margin-right: 7px; margin-left: 18%; margin-bottom: 0px;"/>
                        </div>
                      </card>
                    </div>
                  </div>
                  
                  
                  <hr>
                  
                  <div style="margin-top: 1px; padding-left: 7vh;">
                  <n-button v-if="desarrollo" style="border: 2px solid #FF6600 !important;" class="btn-continuar" @click.native="stripe_procesaPago">Pagar con Stripe</n-button>

                  <!-- Botón continuar -->
                  <n-button v-if="tamelegido==false" size="lg" class="btn-continuar" :disabled="true" style="border: 2px solid #FF6600 !important; cursor: default; opacity: 1;">{{mensaje('men118')}}
                    <el-tooltip class="tooltip-message" :content="mensaje('men116')" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </n-button>
                  <n-button v-if="tamelegido==true" style="border: 2px solid #FF6600 !important;"  size="lg" class="btn-continuar" @click.native="nextStep">{{mensaje('men118')}}</n-button>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,-40%); line-height: normal;">contratar.json->mensajes:men118</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-25%,70%); line-height: normal;">contratar.json->mensajes:men116</span>
                  </div>
                  
                  
                </div>
                
                <!--
                    ************************************************************************************************************************
                      PÁGINA DE FICHA DE DATOS PERSONALES
                    ************************************************************************************************************************
                -->
                <div v-else-if="activeStep === 1" style="padding-left: 17px; overflow-x: hidden; padding-right: 17px;">
                  <!-- Contenido del paso 2 -->
                  <h2 style="font-weight: 800; padding-top: 30px;">{{mensaje('men107')}}</h2>
                  
                  <div class="row" v-if="tamelegido==true">
                    <!-- Nombre -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men33')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men33</span>
                        <fg-input  
                          v-model="contrato.nombre"
                          :error="errornombre"
                          @input="controlanombre">
                        </fg-input>
                    </div>
                    <!-- Apellido1 -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men34')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men34</span>
                        <fg-input
                          v-model="contrato.apellido1"
                          :error="errorape1"
                          @input="controlaape1">
                        </fg-input>
                    </div>
                    <!-- Apellido2 -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men35')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men35</span>
                        <fg-input
                          v-model="contrato.apellido2"
                          :error="errorapellido2"
                          @input="controlapellido2">
                        </fg-input>
                    </div>
                    <!-- CIF -->
                    <div class="col-md-3 pl-2">
                        <label>{{mensaje('men36')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men36</span>
                        <fg-input
                          v-model="contrato.nif"
                          :error="errornif"
                          @input="controlanif">
                        </fg-input>
                    </div>
                    <!-- Teléfono -->
                    <div class="col-md-3 pl-2">
                        <label>{{mensaje('men37')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men37</span>
                        <fg-input
                          v-model="contrato.telefono"
                          :error="errortelefono"
                          @input="controlatelefono">
                        </fg-input>
                    </div>
                    <!-- Email -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men38')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men38</span>
                        <fg-input
                          v-model="contrato.email"
                          :error="erroremail"
                          @blur="minusculas"
                          @input="controlaemail">
                        </fg-input>
                    </div>
                    <!-- Dirección -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men39')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men39</span>
                        <fg-input
                          v-model="contrato.direccion"
                          :error="errordireccion"
                          @input="controladireccion">
                        </fg-input>
                    </div>
                    <!-- CP -->
                    <div class="col-md-4 pl-2">
                        <label>{{mensaje('men40')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men40</span>
                        <fg-input
                          v-model="contrato.cp"
                          :error="errorcp"
                          @input="controlacp">
                        </fg-input>
                    </div>
                    <!-- Localidad -->
                    <div class="col-md-8 pl-2">
                        <label>{{mensaje('men41')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men41</span>
                        <fg-input
                          v-model="contrato.localidad"
                          :error="errorlocalidad"
                          @input="controlalocalidad">
                        </fg-input>
                    </div>
                    <!-- Provincia -->
                    <div class="col-md-6 pl-2">
                        <label>{{mensaje('men42')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men42</span>
                        <fg-input
                            v-model="contrato.provincia"
                            :error="errorprovincia"
                            @input="controlaprovincia">
                        </fg-input>
                    </div>
                    <!-- País -->
                    <div class="col-md-6 pl-2">
                        <label class="mi-label" style="display: block; margin-bottom: -2px;">{{mensaje('men133')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-80%); line-height: normal;">contratar.json->mensajes:men133</span>
                        <el-select class="mi-select" v-model="paisElegido" placeholder="Selecciona un país" placement="bottom-start" popper-append-to-body>
                          <el-option
                            v-for="pais in paises"
                            :key="pais.iso2"
                            :label="pais.nombre"
                            :value="pais.iso2"
                          ></el-option>
                        </el-select>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(60%,-80%); line-height: normal;">contratar.json->paises[]</span>
                    </div>
                    
                    <!-- checkboxConsentirDatos -->
                    <div class="col-md-12 pl-2" style="padding-top:20px;">
                        <n-checkbox v-model="controlarCheck">{{mensaje('men151')}}</n-checkbox><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-100%); line-height: normal;">contratar.json->mensajes:men151</span>
                    </div>
                    
                    <div v-if="sincuentabanco==false" class="row" style="padding-left: 20px; padding-top: 15px;">
                      <!-- Iban -->
                      <div class="col-md-2 pl-2">
                          <label>{{mensaje('men43')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men43</span>
                          <fg-input
                            v-model="contrato.iban"
                            @input="controlaiban"
                            :error="erroriban"
                            v-bind:class="[ibanclass]">
                          </fg-input>
                      </div>
                      <!-- Entidad -->
                      <div class="col-md-2 pl-2">
                          <label>{{mensaje('men44')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men44</span>
                          <fg-input
                            v-model="contrato.entidad"
                            @input="controlaentidad"
                            :error="errorentidad"
                            v-bind:class="[entidclass]">
                          </fg-input>
                      </div>
                      <!-- Oficina -->
                      <div class="col-md-2 pl-2">
                          <label>{{mensaje('men45')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men45</span>
                          <fg-input
                            v-model="contrato.oficina"
                            @input="controlaoficina"
                            :error="erroroficina"
                            v-bind:class="[oficinaclass]">
                          </fg-input>
                      </div>
                      <!-- DC -->
                      <div class="col-md-2 pl-2">
                          <label>{{mensaje('men46')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men46</span>
                          <fg-input
                            v-model="contrato.dc"
                            @input="controladc"
                            :error="errordc"
                            v-bind:class="[dcclass]">
                          </fg-input>
                      </div>
                      <!-- Cuenta -->
                      <div class="col-md-4 pl-2">
                          <label>{{mensaje('men47')}}</label><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-20%); line-height: normal;">contratar.json->mensajes:men47</span>
                          <fg-input
                            v-model="contrato.cuenta"
                            @input="controlacuenta"
                            :error="errorcuenta"
                            v-bind:class="[cuentaclass]">
                          </fg-input>
                      </div>
                    </div> 
                  </div>
                  <!-- Sin DNI -->
                  <div v-if="sindni==false" class="row" style="padding-left: 20px; padding-top: 5px;">
                    <div class="col-md-4 pl-2" style="margin-top: 20px;">
                      <div>{{mensaje('men48')}}</div><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(40%,-90%); line-height: normal;">contratar.json->mensajes:men48</span>
                      <input ref="fileUpload" type="file" @change="previewFile" accept="image/*" hidden>
                      <n-button size="small" type="primary" @click.native="chooseFiles()">{{mensaje('men49')}}</n-button>
                      
                      <card type="blog">
                        <div class="card-title text-center" v-if="showimg=true">
                          <img v-bind:src="dniimagen" style="height:200px; object-fit: contain;" slot="image" class="img rounded">
                        </div>
                        <h6 class="card-subtitle mb-2 text-muted">{{mensaje('men50')}}</h6><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">contratar.json->mensajes:men50</span>
                      </card>
                    </div>
                    
                    <div class="col-md-4 pl-2" style="margin-top: 20px;">
                      <div>{{mensaje('men51')}}</div>
                      <input ref="fileUpload2" type="file" @change="previewFile2" accept="image/*" hidden>
                      <n-button size="small" type="primary" @click.native="chooseFiles2()">{{mensaje('men49')}}</n-button><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-170%,50%); line-height: normal; width: 170px;">contratar.json->mensajes:men49</span>
                  
                      <card type="blog">
                        <div class="card-title text-center" v-if="showimg=true">
                          <img v-bind:src="dniimagen2" style="height:200px; object-fit: contain;" slot="image" class="img rounded">
                        </div>
                        <h6 class="card-subtitle mb-2 text-muted">{{mensaje('men52')}}</h6><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">contratar.json->mensajes:men52</span>
                      </card>
                      
                    </div>
                    

                  </div>
                  
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(250%,-150%); line-height: normal;">MENSAJES DE RESPUESTA DE EVENTOS</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(131%,-50%); line-height: normal;">contratar.json->mensajes:men54, men55, men56, men57, men58, men59</span>
                  
                  <!-- Botón anterior -->
                  <n-button class="btn-continuar" style="border: 2px solid #FF6600 !important;" size="lg" @click.native="previousStep">{{mensaje('men117')}}</n-button><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,150%); line-height: normal;">contratar.json->mensajes:men117</span>

                  <!-- Botón continuar -->
                  <n-button v-if="tamelegido==false" style="border: 2px solid #FF6600 !important;" class="btn-continuar" size="lg" disabled>{{mensaje('men118')}}</n-button>
                  <n-button v-if="tamelegido==true && this.contrato.nombre!=='' && this.contrato.apellido1!=='' && esNifValido && this.contrato.email!=='' && this.contrato.telefono!=='' && this.contrato.direccion!=='' && (this.apellido2Obligatorio && this.contrato.apellido2!=='')" class="btn-continuar" size="lg" @click.native="nextStep">{{mensaje('men118')}}</n-button>
                  <n-button class="btn-continuar" size="lg" v-else :disabled="true" style="border: 2px solid #FF6600 !important; cursor: default; opacity: 1;">{{mensaje('men118')}}
                    <el-tooltip class="tooltip-message" :content="mensaje('men120')" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </n-button>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,150%); line-height: normal;">AYUDA: contratar.json->mensajes:men120</span>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,150%); line-height: normal;">contratar.json->mensajes:men118</span>
                  
                  
                </div>
                
                <!-- 
                    *********************************************************************************************************************************************
                      PÁGINA DE PRECIOS
                    *********************************************************************************************************************************************
                --> 
                <div v-else-if="activeStep === 2">
                  <!-- Contenido del paso 3 -->
                  <h2 style="font-weight: 800; padding-left: 7vh; padding-right: 7vh; padding-top: 30px;">{{mensaje('men108')}}</h2>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(40%,-120%); line-height: normal;">contratar.json->mensajes:men108</span>
                  
                  <div class="row" style="padding-top: 30px; padding-left: 7vh; padding-right: 7vh;">
                    <div class="col-sm-10 col-md-12 ml-auto mr-auto">
                      
                      <!-- 1.- FECHA ESTIMADA DE INICIO -->
                      <div class="row">
                        <div class="col-md-4" style="padding-top: 5px;">
                          <h4 class="text-left" style="font-weight: 600; margin-top: 1px;">{{mensaje('men110')}}</h4>
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(120%,-150%); line-height: normal;">contratar.json->mensajes:men110</span>
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,10%); line-height: normal;">contratar.json->mensajes:men130</span>
                          <el-date-picker
                            type="date"
                            :placeholder="mensaje('men130')"
                            v-model="fechaInicio"
                            :picker-options="datePickerOptions"
                            value-format="yyyy-MM-dd"
                            :format="datePickerFormat"
                            :editable="false"
                            :disabled="isDatePickerDisabled"
                            @change="recalcular(elemobj)"
                            class = "el-input__inner"
                            >
                          </el-date-picker>
                        <img v-if="fechaInicio!==''" class="img" src="img/icon-accept.svg" style="width: 30px;margin-right: 7px; margin-left: 10px; margin-bottom: 0px;"/>
                        </div>
                      </div>
                      <br>
                      <hr>
                      <br>
                      <!-- 2.- POR CUANTO TIEMPO NECESITAS TU ESPACIO -->
                      <h4 class="text-left" style="font-weight: 600; margin-top: 1px;">{{mensaje('men111')}}</h4>
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-150%); line-height: normal;">contratar.json->mensajes:men111</span>
                      <div class="row">
                        <div class="col-md-10">
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-30%); line-height: normal;">contratar.json->tiempoespacio[]:nombre</span>
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,60%); line-height: normal;">contratar.json->tiempoespacio[]:ID(número correlativo)</span>
                          <span style="padding-right: 30px;" v-for="(tiempoes, index) in this.tiempoespacio" :key="index">
                            <el-radio v-model="tiempoesp" :label="tiempoes.ID" @change="recalcular(elemobj)" border>{{tiempoes.NAME}}</el-radio>
                          </span>
                          <img v-if="tiempoesp>0" class="img" src="img/icon-accept.svg" style="width: 30px;margin-right: 7px; margin-left: 0px; margin-bottom: 0px;"/>
                        </div>
                      </div>
                      <br>
                      <hr>
                      <br>
                      <!-- 3.- SELECCION DE ESPACIO -->
                      <h4 class="text-left" style="font-weight: 600; margin-top: 1px;">{{mensaje('men109')}}</h4>
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men109</span>
                      <div class="row" v-if="fechaInicio=='' || tiempoesp==0">
                        <div class="col-md-12 pl-2">
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,20%); line-height: normal;">contratar.json->mensajes:men115 HTML</span>
                          <span v-html="mensaje('men115')" style="padding-left: 15px;"></span>
                          
                        </div>
                        
                      </div>
                      <div class="row" v-if="fechaInicio!=='' && tiempoesp>0">
                        <div class="col-sm-6 col-md-4" v-for="elem in boxesfilt" :key="elem.ID">
                          
                          <card style="width: auto; height: auto;">
                              <h4 class="card-title">M&sup2;: {{elem.MTS_CUA}}</h4>
                              <h6 class="card-subtitle mb-2 text-muted">{{mensaje('men29')}}: {{elem.REF}}</h6>
                              <h6 class="card-subtitle mb-2 text-muted">Planta: {{ nombrePlanta(elem.PLT) }}</h6>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-100%); line-height: normal;">contratar.json->mensajes:men29</span>
                              <p class="card-text text-right" v-show="true" :style="{ fontWeight: tipo_texto ? '' : 'bold', fontSize: '14px' }">{{mensaje('men30')}}: {{(elem.PVP_CON_IVA).toFixed(2)}}€<br>
                              {{mensaje('men31')}}: {{(elem.IMP_DEP).toFixed(2)}}€</p>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-220%); line-height: normal;">contratar.json->mensajes:men30</span>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-140%); line-height: normal;">contratar.json->mensajes:men31</span>
                              <n-button v-if="elegido==false" style="border: 2px solid #FF6600 !important;" @click.native="contratar(elem)"><b>{{mensaje('men32')}}</b></n-button>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-30%,50%); line-height: normal;">contratar.json->mensajes:men32</span>
                              <img v-if="elemelegido==true" class="icono-aceptado3" src="img/icon-accept.svg" style="width: 30px;margin-right: 7px; margin-left: 5px; margin-bottom: 0px;"/>
                              <n-button v-if="elemelegido" class="btn-bot" @click.native="volver2()">
                                <b>{{mensaje('men28')}}</b>
                              </n-button>  
                          </card>
                        </div>
                      </div>
                      <br>
                        <h4 v-if="fechaInicio!=='' && tiempoesp>0" style="font-weight: bold;">Calcula tu espacio</h4>
                        <div v-if="fechaInicio!=='' && tiempoesp>0" style="display: flex; gap: 16px; align-items: center; font-size: 1.1em;">
                          <select v-model="tipoElemento" class="form-control" style="max-width: 300px; border-radius: 20px;">
                          <option value="Selecciona la referencia de tamaño">Selecciona la referencia de tamaño</option>
                          <option value="Furgonetas">Furgonetas</option>
                          <option value="Cajas">Cajas</option>
                          <option value="Habitaciones">Habitaciones</option>
                          <option value="Archivos">Archivos</option>
                          <option value="Contenedores">Contenedores</option>
                        </select>
                        <select
                          v-if="tipoElemento === 'Furgonetas'"
                          v-model="cantidadSeleccionada"
                          class="form-control"
                          style="max-width: 300px; border-radius: 20px; ">
                          <option value="Selecciona la cantidad">Selecciona la cantidad</option>
                          <option value="0,3">0,3</option>
                          <option value="0,5">0,5</option>
                          <option value="1">1</option>
                          <option value="1,5">1,5</option>
                          <option value="2">2</option>
                        </select>
                        <select
                          v-if="tipoElemento === 'Cajas'"
                          v-model="cantidadSeleccionada"
                          class="form-control"
                          style="max-width: 300px; border-radius: 20px;">
                          <option value="Selecciona la cantidad">Selecciona la cantidad</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="75">75</option>
                          <option value="100">100</option>
                          <option value="150">150</option>
                        </select>
                        <select
                          v-if="tipoElemento === 'Habitaciones'"
                          v-model="cantidadSeleccionada"
                          class="form-control"
                          style="max-width: 300px; border-radius: 20px;">
                          <option value="Selecciona la cantidad">Selecciona la cantidad</option>
                          <option value="Estudio">Estudio</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                        <select
                          v-if="tipoElemento === 'Archivos'"
                          v-model="cantidadSeleccionada"
                          class="form-control"
                          style="max-width: 300px; border-radius: 20px;">
                          <option value="Selecciona la cantidad">Selecciona la cantidad</option>
                          <option value="100">100</option>
                          <option value="250">250</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                          <option value="2000">2000</option>
                        </select>
                      <select
                          v-if="tipoElemento === 'Contenedores'"
                          v-model="cantidadSeleccionada"
                          class="form-control"
                          style="max-width: 300px; border-radius: 20px;">
                          <option value="Selecciona la cantidad">Selecciona la cantidad</option>
                          <option value="0,3">0,3</option>
                          <option value="0,5">0,5</option>
                          <option value="1">1</option>
                          <option value="1,5">1,5</option>
                          <option value="2">2</option>
                        </select>
                      </div>
                      <div v-if="metrosCuadradosTexto" class="textoCalculadora"
                        style="margin-top: 32px; background: #FF5722; color: white; border-radius: 32px; padding: 32px; width: auto; max-width: 800px; font-size: 2em; font-weight: bold;">
                        <div style="text-align: left; font-size: 1.1em; margin-bottom: 0.2em;">
                          Según tu selección
                        </div>
                        <div style="display: flex; align-items: center;">
                          <div style="font-size: 1.1em; margin-bottom: 0;">
                            necesitarás un trastero de:
                          </div>
                          <span style="font-size: 2.0em; display: flex; font-weight: bold; margin-left: 12px;">{{ metrosCuadradosTexto }}</span>
                        </div>
                      </div>
                      <br>
                      <hr>
                      <br>
                      <!-- 4.- CUENTANOS UN POCO MAS -->
                      <h4 class="text-left" style="font-weight: 600; margin-top: 1px;">{{mensaje('men112')}}</h4>
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men112</span>
                      
                      <!-- Motivo necesidad de espacio -->
                      <div class="row">
                        <div class="col-md-5">
                          <span v-if="valorMotivo !== null" style="padding-left: 10px; padding-bottom: -15px;">{{mensaje('men113')}}
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">contratar.json->mensajes:men113</span>
                          </span>
                          <el-select v-model="valorMotivo" :placeholder="mensaje('men113')" size="large" class="select-default" style="margin-top: -8px;">
                            <div v-for="(motivoes, index) in this.motivoespacio" :key="index">
                            <el-option :label="motivoes.nombre" :value="motivoes.label"></el-option>
                            </div>
                          </el-select>
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->motivoespacio[]:nombre</span>
                        </div>
                      </div>
                      
                      <!-- ¿Donde has oído hablar de nosotros? -->
                      <div class="row">
                        <div class="col-md-5">
                          <span v-if="valorFuente !== null" style="padding-left: 10px;">{{mensaje('men114')}}
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-10%); line-height: normal;">contratar.json->mensajes:men114</span>
                          </span>
                          <el-select v-model="valorFuente" :placeholder="mensaje('men114')" size="large" class="select-default" style="margin-top: -8px;">
                            <div v-for="(fuentees, index) in this.fuenteespacio" :key="index">
                            <el-option :label="fuentees.nombre" :value="fuentees.label"></el-option>
                            </div>
                          </el-select>
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->fuenteespacio[]:nombre</span>
                        </div>
                      </div>
                      
                      <div v-if="pagopasarela==true">
                      <br>
                      <hr>
                      <br>
                      <!-- 5.- DATOS DE PAGO -->
                      <h4 class="text-left" style="font-weight: 600; margin-top: 1px;">{{mensaje('men132')}}</h4>
                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-150%); line-height: normal;">contratar.json->mensajes:men132</span>
                      <div class="row" v-if="boxelegido==true">
                        <div class="col-sm-6 col-md-5 pl-2">
                          <card style="width: auto; height: auto;">
                              <h4 class="card-title">{{mensaje('men134')}}</h4>
                              <h6 class="card-subtitle mb-2 text-muted">{{mensaje('men135')}}</h6>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(130%,-190%); line-height: normal;">contratar.json->mensajes:men134</span>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(90%,-100%); line-height: normal;">contratar.json->mensajes:men135</span>
                              <p class="card-text" style="font-size: 12px;">{{mensaje('men136')}} <b>{{fch_dsd_web}}</b> {{mensaje('men137')}} <b>{{fch_hst_web}}</b></p>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-70%); line-height: normal;">contratar.json->mensajes:men136 y men137</span>
                              <p class="card-text text-right" style="font-size: 14px;">{{mensaje('men152')}} <b>{{imp_dep}}€</b></p>
                              <p class="card-text text-right" style="font-size: 14px;">{{mensaje('men138')}} <b>{{pvp_men}}€ <span>( {{mensaje('men136')}} {{fch_dsd_web}} {{mensaje('men137')}} {{fch_hst_web}} )</span></b></p>
                              <p class="card-text text-right" style="font-size: 14px;">{{mensaje('men153')}} <b>{{pvp_web}}€</b></p>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(150%,-100%); line-height: normal;">contratar.json->mensajes:men138</span>
                              <h4 class="card-title">{{mensaje('men142')}}</h4>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(80%,-130%); line-height: normal;">contratar.json->mensajes:men142</span>
                              <h6 class="card-subtitle mb-2 text-muted">{{mensaje('men139')}}</h6>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-100%); line-height: normal;">contratar.json->mensajes:men139</span>
                              <p class="card-text" style="font-size: 12px;">{{mensaje('men140')}} <b>{{fch_pro_pag_web}}</b></p>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-100%); line-height: normal;">contratar.json->mensajes:men140</span>
                              <p class="card-text text-right" style="font-size: 14px;">{{mensaje('men141')}} <b>{{pvp_con_iva}}€</b></p>
                              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(150%,-100%); line-height: normal;">contratar.json->mensajes:men141</span>
                          </card>
                        </div>
                      </div>
                      </div>
                      <br>
                      <hr>
                      <br>
                      <!-- Autorizar contrato -->
                      <div class="col-md-12 pl-2" style="padding-top:30px;">
                        <span v-html="mensaje('men22')"></span><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,-90%); line-height: normal;">contratar.json->mensajes:men22 <i>HTML</i></span>
                        <n-checkbox v-model="autorizo">{{mensaje('men23')}}</n-checkbox><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,-100%); line-height: normal;">contratar.json->mensajes:men23</span>
                      </div>
                      
                      <!-- Autorizar recurrente -->
                      <div class="row pl-3" style="padding-bottom: 30px;">
                        <div v-if="pagopasarela==true" class="col-md-12 pl-2" style="padding-left: 20px; padding-top: 5px;">
                          <div class="row" style="padding-top:5px; padding-left: 15px;">
                            <n-checkbox v-model="pagorec" :disabled="tipopasarela === 'lyra'">{{mensaje('men21')}}</n-checkbox><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,30%); line-height: normal;">contratar.json->mensajes:men21</span>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Tarjeta o SEPA -->
                      <div class="row pl-3" style="padding-bottom: 30px; margin-top: -20px;">
                        <div v-if="pagopasarela==true && tipopasarela ==='lyra'" class="col-md-12 pl-2" style="padding-left: 20px; padding-top: 5px;">
                          <div class="row" style="padding-top:5px; padding-left: 15px;">
                            <el-switch v-model="sepa_tarjeta" :active-text="mensaje('men145')" :inactive-text="mensaje('men144')"></el-switch>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(100%,30%); line-height: normal;">contratar.json->mensajes:men144 y men145</span>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  
                  <!-- Botón anterior -->
                  <div style="padding-left: 7vh;">
                  <n-button type="info" size="lg" style="border: 2px solid #FF6600 !important;" class="btn-continuar" @click.native="previousStep">{{mensaje('men117')}}</n-button>
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">contratar.json->mensajes:men117</span>
                  
                  
                  <!-- Botón enviar contrato -->
                  <n-button type="info" size="lg" class="btn-continuar" @click.native="enviacontrato" v-if="fechaInicio!=='' && elemelegido==true && tiempoesp>0 && pagopasarela==false">{{mensaje('men53')}}
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">contratar.json->mensajes:men53</span>
                  </n-button>
                  
                  <!--<n-button type="info" size="lg" v-else :disabled="true" style="cursor: default; opacity: 1;">{{mensaje('men53')}}
                    <el-tooltip class="tooltip-message" :content="mensaje('men116')" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </n-button>-->
                  
                  <!--
                   ---------------------------------- 
                   BOTON DE PAGO CON REDSYS TARJETA
                   ---------------------------------- 
                  -->
                  <n-button type="info" size="lg" class="btn-continuar" @click.native="enviacontrato" v-if="fechaInicio!=='' && elemelegido==true && tiempoesp>0 && pagopasarela==true && tipopasarela=='redsys'" style="cursor: default; opacity: 1;">{{mensaje('men53')}}
                    <el-tooltip class="tooltip-message" :content="mensaje('men116')" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </n-button>
                  </div>
                  
                  <!--
                   ---------------------------------- 
                   BOTON DE PAGO CON LYRA TARJETA
                   ---------------------------------- 
                  -->
                  <div v-if="fechaInicio!=='' && elemelegido==true && tiempoesp>0 && pagopasarela==true && tipopasarela=='lyra' && pagorec==false">
                  <form method="POST" action="https://secure.lyra.com/vads-payment/" ref="lyraPaymentForm">
                    <input type="hidden" name="vads_action_mode" :value="lyra_vads_action_mode" /> 
                    <input type="hidden" name="vads_amount" :value="lyra_vads_amount" />
                    <input type="hidden" name="vads_ctx_mode" :value="lyra_vads_ctx_mode" />
                    <input type="hidden" name="vads_currency" :value="lyra_vads_currency" />
                    <input type="hidden" name="vads_page_action" :value="lyra_vads_page_action" />
                    <input type="hidden" name="vads_payment_config" :value="lyra_vads_payment_config" />
                    <input type="hidden" name="vads_site_id" :value="lyra_vads_site_id" />
                    <input type="hidden" name="vads_trans_date" :value="lyra_vads_trans_date" />
                    <input type="hidden" name="vads_trans_id" :value="lyra_vads_trans_id" />
                    <input type="hidden" name="vads_version" :value="lyra_vads_version" />
                    <input type="hidden" name="vads_payment_cards" :value="lyra_vads_payment_cards" />
                    <input type="hidden" name="vads_order_id" :value="lyra_vads_order_id" />
                    <input type="hidden" name="vads_order_info" :value="lyra_vads_order_info" />
                    <input type="hidden" name="vads_order_info2" :value="lyra_vads_order_info2" />
                    <input type="hidden" name="vads_order_info3" :value="lyra_vads_order_info3" />
                    <input type="hidden" name="vads_cust_email" :value="lyra_vads_cust_email" />
                    
                    <input type="hidden" name="vads_ext_info_ape1" :value="lyra_vads_ext_info_ape1" />
                    <input type="hidden" name="vads_ext_info_ape2" :value="lyra_vads_ext_info_ape2" />
                    <input type="hidden" name="vads_ext_info_nom" :value="lyra_vads_ext_info_nom" />
                    <input type="hidden" name="vads_ext_info_telefono" :value="lyra_vads_ext_info_telefono" />
                    <input type="hidden" name="vads_ext_info_nif" :value="lyra_vads_ext_info_nif" />
                    <input type="hidden" name="vads_ext_info_direccion" :value="lyra_vads_ext_info_direccion" />
                    <input type="hidden" name="vads_ext_info_cp" :value="lyra_vads_ext_info_cp" />
                    <input type="hidden" name="vads_ext_info_localidad" :value="lyra_vads_ext_info_localidad" />
                    <input type="hidden" name="vads_ext_info_provincia" :value="lyra_vads_ext_info_provincia" />
                    <input type="hidden" name="vads_ext_info_pais" :value="lyra_vads_ext_info_pais" />
                    
                    <input type="hidden" name="vads_ext_info_centro" :value="lyra_vads_ext_info_centro" />
                    <input type="hidden" name="vads_ext_info_box" :value="lyra_vads_ext_info_box" />
                    <input type="hidden" name="vads_ext_info_precio" :value="lyra_vads_ext_info_precio" />
                    <input type="hidden" name="vads_ext_info_deposito" :value="lyra_vads_ext_info_deposito" />
                    
                    <input type="hidden" name="signature" :value="lyra_signature" />
                    <n-button type="info" size="lg" @click.native="lyra_procesaPago">{{mensaje('men131')}}</n-button>
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">contratar.json->mensajes:men131</span>
                  </form>
                  </div>
                  <!--<n-button type="info" size="lg" @click.native="lyra_generaFirma">Genera Firma</n-button>-->
                  <!--
                   --------------------------------------------------------------- 
                   BOTON DE PAGO CON LYRA TARJETA SUSCRIPCION Y OBTENCION DE TOKEN
                   --------------------------------------------------------------- 
                  -->
                  <div v-if="fechaInicio!=='' && elemelegido==true && tiempoesp>0 && pagopasarela==true && tipopasarela=='lyra' && sepa_tarjeta==true && pagorec==true">
                  <form method="POST" action="https://secure.lyra.com/vads-payment/" ref="lyraPaymentForm"> 
                    <input type="hidden" name="vads_action_mode" :value="lyra_vads_action_mode" />
                    <input type="hidden" name="vads_amount" :value="lyra_vads_amount" />
                    <input type="hidden" name="vads_ctx_mode" :value="lyra_vads_ctx_mode" />
                    <input type="hidden" name="vads_currency" :value="lyra_vads_currency" />
                    <input type="hidden" name="vads_cust_email" :value="lyra_vads_cust_email" />
                    <input type="hidden" name="vads_order_id" :value="lyra_vads_order_id" />
                    <input type="hidden" name="vads_order_info" :value="lyra_vads_order_info" />
                    <input type="hidden" name="vads_order_info2" :value="lyra_vads_order_info2" />
                    <input type="hidden" name="vads_order_info3" :value="lyra_vads_order_info3" />
                    <input type="hidden" name="vads_page_action" :value="lyra_vads_page_action" />
                    <input type="hidden" name="vads_payment_cards" :value="lyra_vads_payment_cards" />
                    <input type="hidden" name="vads_payment_config" :value="lyra_vads_payment_config" />
                    <input type="hidden" name="vads_site_id" :value="lyra_vads_site_id" />
                    <input type="hidden" name="vads_sub_amount" :value="lyra_vads_sub_amount" />
                    <input type="hidden" name="vads_sub_currency" :value="lyra_vads_sub_currency" />
                    <input type="hidden" name="vads_sub_desc" :value="lyra_vads_sub_desc" />
                    <input type="hidden" name="vads_sub_effect_date" :value="lyra_vads_sub_effect_date" />
                    <input type="hidden" name="vads_trans_date" :value="lyra_vads_trans_date" />
                    <input type="hidden" name="vads_trans_id" :value="lyra_vads_trans_id" />
                    <input type="hidden" name="vads_version" :value="lyra_vads_version" />
                    
                    <input type="hidden" name="vads_ext_info_ape1" :value="lyra_vads_ext_info_ape1" />
                    <input type="hidden" name="vads_ext_info_ape2" :value="lyra_vads_ext_info_ape2" />
                    <input type="hidden" name="vads_ext_info_nom" :value="lyra_vads_ext_info_nom" />
                    <input type="hidden" name="vads_ext_info_telefono" :value="lyra_vads_ext_info_telefono" />
                    <input type="hidden" name="vads_ext_info_nif" :value="lyra_vads_ext_info_nif" />
                    <input type="hidden" name="vads_ext_info_direccion" :value="lyra_vads_ext_info_direccion" />
                    <input type="hidden" name="vads_ext_info_cp" :value="lyra_vads_ext_info_cp" />
                    <input type="hidden" name="vads_ext_info_localidad" :value="lyra_vads_ext_info_localidad" />
                    <input type="hidden" name="vads_ext_info_provincia" :value="lyra_vads_ext_info_provincia" />
                    <input type="hidden" name="vads_ext_info_pais" :value="lyra_vads_ext_info_pais" />
                    
                    <input type="hidden" name="vads_ext_info_centro" :value="lyra_vads_ext_info_centro" />
                    <input type="hidden" name="vads_ext_info_box" :value="lyra_vads_ext_info_box" />
                    <input type="hidden" name="vads_ext_info_precio" :value="lyra_vads_ext_info_precio" />
                    <input type="hidden" name="vads_ext_info_deposito" :value="lyra_vads_ext_info_deposito" />
                    
                    <input type="hidden" name="signature" :value="lyra_signature" />
                    <n-button type="info" size="lg" @click.native="lyra_procesaPago">{{mensaje('men131')}}</n-button>
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">contratar.json->mensajes:men131</span>
                  </form>
                  </div>
                  
                  <!--
                   ----------------------------------------------------------------- 
                   BOTON DE PAGO CON LYRA SEPA MANDATO RECURRENTE Y EFECTUAR UN PAGO
                   ----------------------------------------------------------------- 
                  -->
                  <div v-if="fechaInicio!=='' && elemelegido==true && tiempoesp>0 && pagopasarela==true && tipopasarela=='lyra' && sepa_tarjeta==false && pagorec==true">
                  <form method="POST" action="https://secure.lyra.com/vads-payment/" ref="lyraPaymentForm3"> 
                    <input type="hidden" name="vads_action_mode" :value="lyra_vads_action_mode" />
                    <input type="hidden" name="vads_amount" :value="lyra_vads_amount" />
                    <input type="hidden" name="vads_ctx_mode" :value="lyra_vads_ctx_mode" />
                    <input type="hidden" name="vads_currency" :value="lyra_vads_currency" />
                    <input type="hidden" name="vads_cust_email" :value="lyra_vads_cust_email" />
                    <input type="hidden" name="vads_page_action" :value="lyra_vads_page_action" />
                    <input type="hidden" name="vads_payment_cards" :value="lyra_vads_payment_cards" />
                    <input type="hidden" name="vads_payment_config" :value="lyra_vads_payment_config" />
                    <input type="hidden" name="vads_site_id" :value="lyra_vads_site_id" />
                    <input type="hidden" name="vads_trans_date" :value="lyra_vads_trans_date" />
                    <input type="hidden" name="vads_trans_id" :value="lyra_vads_trans_id" />
                    <input type="hidden" name="vads_version" :value="lyra_vads_version" />
                    <input type="hidden" name="vads_cust_address" :value="lyra_vads_cust_address" />
                    <input type="hidden" name="vads_cust_cell_phone" :value="lyra_vads_cust_cell_phone" />
                    <input type="hidden" name="vads_cust_country" :value="lyra_vads_cust_country" />
                    <input type="hidden" name="vads_cust_first_name" :value="lyra_vads_cust_first_name" />
                    <input type="hidden" name="vads_cust_last_name" :value="lyra_vads_cust_last_name" />

                    <input type="hidden" name="vads_order_id" :value="lyra_vads_order_id" />
                    <input type="hidden" name="vads_order_info" :value="lyra_vads_order_info" />
                    <input type="hidden" name="vads_order_info2" :value="lyra_vads_order_info2" />
                    <input type="hidden" name="vads_order_info3" :value="lyra_vads_order_info3" />
                    
                    <input type="hidden" name="vads_ext_info_ape1" :value="lyra_vads_ext_info_ape1" />
                    <input type="hidden" name="vads_ext_info_ape2" :value="lyra_vads_ext_info_ape2" />
                    <input type="hidden" name="vads_ext_info_nom" :value="lyra_vads_ext_info_nom" />
                    <input type="hidden" name="vads_ext_info_telefono" :value="lyra_vads_ext_info_telefono" />
                    <input type="hidden" name="vads_ext_info_nif" :value="lyra_vads_ext_info_nif" />
                    <input type="hidden" name="vads_ext_info_direccion" :value="lyra_vads_ext_info_direccion" />
                    <input type="hidden" name="vads_ext_info_cp" :value="lyra_vads_ext_info_cp" />
                    <input type="hidden" name="vads_ext_info_localidad" :value="lyra_vads_ext_info_localidad" />
                    <input type="hidden" name="vads_ext_info_provincia" :value="lyra_vads_ext_info_provincia" />
                    <input type="hidden" name="vads_ext_info_pais" :value="lyra_vads_ext_info_pais" />
                    
                    <input type="hidden" name="vads_ext_info_centro" :value="lyra_vads_ext_info_centro" />
                    <input type="hidden" name="vads_ext_info_box" :value="lyra_vads_ext_info_box" />
                    <input type="hidden" name="vads_ext_info_precio" :value="lyra_vads_ext_info_precio" />
                    <input type="hidden" name="vads_ext_info_deposito" :value="lyra_vads_ext_info_deposito" />
                    
                    <input type="hidden" name="signature" :value="lyra_signature" />
                    <n-button type="info" size="lg" @click.native="lyra_procesaPagoSEPA">{{mensaje('men143')}}</n-button>
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">contratar.json->mensajes:men143</span>
                  </form>
                  </div>
                  
                </div>
              </div>
              
            </div>
          </div>
          
          
          <modal :show.sync="dialogVisible" headerClasses="justify-content-center">
            <!--<h4 slot="header" class="title title-up">Muchas Gracias por Contratar</h4>
            <p>Su informacion ha sido grabada correctamente. Le enviaremos el contrato.</p>-->
            <h4 slot="header" class="title title-up">{{mensaje('men54')}}</h4>
            <p>{{mensaje('men55')}}</p>
            <template slot="footer">
              <n-button type="primary" @click.native="dialogVisible = false">{{mensaje('men56')}}</n-button>
            </template>
          </modal>
          
          <modal :show.sync="faltancampos" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{mensaje('men57')}}</h4>
            <p>{{mensaje('men58')}}</p>
            <template slot="footer">
              <n-button type="primary" @click.native="faltancampos= false">{{mensaje('men56')}}</n-button>
            </template>
          </modal>
          
          <modal :show.sync="aceptaterminos" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{mensaje('men57')}}</h4>
            <p>{{mensaje('men59')}}</p>
            <template slot="footer">
              <n-button type="primary" @click.native="aceptaterminos= false">{{mensaje('men56')}}</n-button>
            </template>
          </modal>
        </div>

</template>
<script>
  import { Card, Button, Comment, Badge, DropDown, FormGroupInput, InfoSection, Modal, Checkbox } from '@/components';
  import {Select, Option, Tag, Steps, Step, Radio, DatePicker, Tooltip, Switch, Notification} from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css'
  import 'element-ui/lib/theme-chalk/icon.css'
  import 'element-ui/lib/theme-chalk/radio.css'
  import {RUTA_BASE} from '@/constants'
  import {RUTA_PHP} from '@/constants'
  //import {PAGO_PASARELA, TIPO_PASARELA} from '@/constants'
  //import {CENTRO_PASARELA} from '@/constants'
  import {ALLBOX_WEB_VERSION} from '@/constants'
  //import {RUTA_PASARELA, RUTA_PASARELA_BANCO, SIN_CUENTA_BANCO, SIN_DNI} from '@/constants'
  //import {API_KEY} from '@/constants'
  import axios from "axios"
  import { v4 as uuidv4 } from 'uuid'
  import Vue, { ref } from 'vue'

  export default {
    name: 'contratar2',
    bodyClass: 'blog-post',
    components: {
      Modal,
      Card,
      InfoSection,
      Badge,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Radio.name]: Radio,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      [Tooltip.name]: Tooltip,
      [Switch.name]: Switch,
      [Step.name]: Step,
      [Steps.name]: Steps,
      [Tag.name]: Tag,
      [FormGroupInput.name]: FormGroupInput,
      [Notification.name]: Notification,
    },
    props: {
      pago: {
        type: String, // Es de tipo cadena
        default: '' // Valor predeterminado si `pago` es undefined
      }
    },
    data() {
      return {
        desarrollo: false,
        api_google: this.$store.state.api_key,
        latitude: 43.29900435152909,
        longitude: -3.0065606757206913,
        centrosel: {},
        centroid: '1',
        fechaInicio: this.formatDate(new Date()),
        tipoesp: 0,
        tipoElemento: 'Selecciona la referencia de tamaño',
        cantidadSeleccionada:'Selecciona la cantidad',
        tiempoesp: 0,
        tipo_texto:false,
        sepa_tarjeta: true,
        valorMotivo: null,
        valorFuente: null,
        tiposespacio: {},
        tiempoespacio: {},
        plantaseleccion: {},
        //datospago: {},
        motivoespacio: {},
        fuenteespacio: {},
        eligeProducto: false,
        tamelegido: false,
        elemelegido: false,
        activeStep: 0,
        datePickerOptions: {
          disabledDate: (date) => {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth();
            const day = today.getDate();
            
            if (date.getFullYear() === year && date.getMonth() === month) {
            
              if (day >= 1 && day <= 15) {
                return date.getDate() < day || date.getDate() > 15;
              }
              
              if (day >= 16 && day <= 31) {
                return date.getDate() < day || date.getDate() > 31;
              }
            } else {
              
              return true;
            }
            return false;
          }
        },
        isDatePickerDisabled: true,
        datePickerFormat: 'dd/MM/yyyy',
        faltancampos: false,
        aceptaterminos: false,
        erroriban: '',
        errorentidad: '',
        erroroficina: '',
        errordc: '',
        errorcuenta: '',
        errornombre: '* Requerido',
        errorape1: '* Requerido',
        errornif: '* Requerido',
        erroremail: '* Requerido',
        errortelefono: '* Requerido',
        errordireccion: '* Requerido',
        ibanclass: 'has-success',
        entidclass: 'has-success',
        oficinaclass: 'has-success',
        dcclass: 'has-success',
        cuentaclass: 'has-success',
        dialogVisible: false,
        mensajes: [],
        ventajas: [],
        centros:[],
        tamvalor: '',
        plantavalor: '',
        medidas: {},
        plantas: {},
        boxes: {},
        boxesfilt: [],
        elegido: false,
        elemobj: {},
        pagopasarela: false,
        tipopasarela: '',
        sincuentabanco: false,
        controlarCheck: true,
        sindni: false,
        pagorec: true,
        autorizo: false,
        dniimagen: '',
        dniimagen2: '',
        contrato: {
          nombre: '',
          apellido1: '',
          apellido2: '',
          telefono: '',
          email: '',
          cp: '',
          nif: '',
          direccion: '',
          localidad: '',
          provincia: '',
          iban: '',
          entidad: '',
          oficina: '',
          dc: '',
          cuenta: '',
          box: '',
          ref: '',
          precio: '',
          deposito: '',
          origen: 'CONTRATO',
          fp: 1,
          comentario: ''
        },
        
        dias_web: '',
        dto_web: '',
        imp_dep: '',
        pvp_con_iva: '',
        pvp_dia: '',
        refbox: '',
        pvp_men: '',
        pvp_web: '',
        fch_dsd_web: '',
        fch_hst_web: '',
        fch_pro_pag_web: '',
        boxelegido: false,
        controlar_NIF: false,
        logo_altura: 0,
        
        lyra_vads_action_mode: 'INTERACTIVE',
        lyra_vads_amount: '2595',
        lyra_vads_ctx_mode: 'TEST',
        lyra_vads_currency: '978',
        lyra_vads_page_action: 'PAYMENT',
        lyra_vads_payment_config: 'SINGLE',
        //lyra_vads_site_id: '55297050',  Tienda pruebas CEESA
        lyra_vads_site_id: '97190852', //Tienda Cayo Nordisqui Pruebas
        lyra_vads_trans_date: '20230809103425',
        lyra_vads_trans_id: '123456',
        lyra_vads_version: 'V2',
        lyra_vads_payment_cards: 'VISA;MASTERCARD;AMEX;VISA_ELECTRON',
        lyra_vads_order_id: '',
        lyra_vads_order_info: '',
        lyra_vads_order_info2: '',
        lyra_vads_order_info3: '',
        
        lyra_vads_cust_address: '',
        lyra_vads_cust_cell_phone: '',
        lyra_vads_cust_country: '',
        lyra_vads_cust_first_name: '',
        lyra_vads_cust_last_name: '',
        
        lyra_vads_ext_info_ape1: '',
        lyra_vads_ext_info_ape2: '',
        lyra_vads_ext_info_nom: '',
        lyra_vads_ext_info_telefono: '',
        lyra_vads_ext_info_nif: '',
        lyra_vads_ext_info_direccion: '',
        lyra_vads_ext_info_cp: '',
        lyra_vads_ext_info_localidad: '',
        lyra_vads_ext_info_provincia: '',
        lyra_vads_ext_info_pais: '',
        lyra_vads_ext_info_centro: '',
        lyra_vads_ext_info_box: '',
        lyra_vads_ext_info_precio: '',
        lyra_vads_ext_info_deposito: '',
        
        lyra_vads_cust_email: '',
        lyra_vads_sub_amount: '',
        lyra_vads_sub_currency: '978',
        lyra_vads_sub_desc: '',
        lyra_vads_sub_effect_date: '',
        
        lyra_signature: '',
        
        paisElegido: 'ES',
        paises: {},
        headerSimple: false,
        
        apellido2Obligatiorio: false,
        cpObligatiorio: false,
        localidadObligatorio: false,
        provinciaObligatorio: false,
        errorapellido2: '',
        errorcp: '',
        errorlocalidad: '',
        errorprovincia: '',
        

      }
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
      
      tipoElemento() {
        this.cantidadSeleccionada = 'Selecciona la cantidad';
      }
    },
    methods: {
      tipoespCambia(nuevoVal) {
        console.log("Nuevo Valor: ",nuevoVal)
        var medtmp = this.medidas
        medtmp.forEach((med,index) => {
          if (med.TIP == nuevoVal) {
            Vue.set(this.medidas, index, {...med, visible: true})
          } else {
            Vue.set(this.medidas, index, {...med, visible: false})
          }
        })

        this.tamelegido = false;
        this.elemelegido = false;
        this.elegido = false;
        this.boxelegido = false;
        this.boxesfilt = [];
        this.tamvalor = '';
        this.plantavalor = '';
        this.elemobj = {};
        
      },
      
      async stripe_procesaPago() {
        try {
          // Datos del producto
          const productData = {
            name: 'Producto de prueba',
            description: 'Box nº 345 con 1,5 x 2,3 mts. con seguridad e iluminación',
            images: ['https://allboxmanager.info/allboxdemo/recursos/img/trastero1.jpg'],
            amount: 2000, // Monto en centavos (20 USD)
            currency: 'usd',
            quantity: 1
          };
          // Solicita la creación de una sesión de pago al servidor
          const response = await axios.post(RUTA_PHP + 'stripepago.php', productData);
        
          // Redirige a Stripe Checkout
          const stripe = Stripe('pk_test_51KmFCbFJRFN1QuT7tERt57AbbzlWEgyw6jzRYYYWikpuiOSniG0iq1JqmHyBBwXbNe9kyYeU0CjfmuNZu5xBsi3b00EgREH323'); // Reemplaza con tu clave publicable
          await stripe.redirectToCheckout({ sessionId: response.data.id });
        } catch (error) {
          console.error('Error al redirigir a Stripe:', error);
        }
      },
      
      
      async lyra_procesaPago() {
        // COMPROBAMOS SI TENEMOS MARCADO EL CHECK DE ACEPTO LOS TERMINOS DEFINIDOS EN ESTE CONTRATO
        if (this.autorizo==true) {
          if (this.pagorec==true) {
            var prectot = parseInt(parseFloat(this.contrato.precio).toFixed(2)*100);
            var precstr = prectot.toString()
            this.lyra_vads_page_action = "REGISTER_PAY_SUBSCRIBE"
            this.lyra_vads_cust_email = this.contrato.email
            this.lyra_vads_sub_amount = this.pvp_con_iva.replace(',','')
            this.lyra_vads_sub_desc = "RRULE:FREQ=MONTHLY"
            this.lyra_vads_sub_effect_date = this.formatearFechaInicio(this.fechaInicio)
          } else {
            this.lyra_vads_page_action = "PAYMENT"
            this.lyra_vads_cust_email = this.contrato.email
            this.lyra_vads_sub_amount = ""
            this.lyra_vads_sub_desc = ""
            this.lyra_vads_sub_effect_date = ""
          }
          this.lyra_vads_trans_id = await this.generarCodigoUnico();
          this.lyra_vads_trans_date = this.obtenerFechaHoraActual();
          this.lyra_vads_ext_info_ape1 = this.contrato.apellido1;
          this.lyra_vads_ext_info_ape2 = this.contrato.apellido2;
          this.lyra_vads_ext_info_nom = this.contrato.nombre;
          this.lyra_vads_ext_info_telefono = this.contrato.telefono;
          this.lyra_vads_ext_info_nif = this.contrato.nif;
          this.lyra_vads_ext_info_direccion = this.contrato.direccion;
          this.lyra_vads_ext_info_cp = this.contrato.cp;
          this.lyra_vads_ext_info_localidad = this.contrato.localidad;
          this.lyra_vads_ext_info_provincia = this.contrato.provincia;
          this.lyra_vads_ext_info_pais = this.paisElegido;
          this.lyra_vads_ext_info_centro = this.centroid;
          this.lyra_vads_ext_info_box = this.contrato.box;
          this.lyra_vads_ext_info_precio = this.contrato.precio;
          this.lyra_vads_ext_info_deposito = this.contrato.deposito;
          
          this.lyra_vads_amount = this.pvp_web.replace(',','')
          this.lyra_vads_order_id = uuidv4();
          this.lyra_vads_order_info = this.contrato.ref;
          this.lyra_vads_order_info2 = this.formatearFechaInicio(this.fechaInicio);
          this.lyra_vads_order_info3 = this.tiempoesp;
          await this.lyra_generaFirma();
          this.$refs.lyraPaymentForm.submit();
        } else {
          this.aceptaterminos=true
        }
      },
      
      async lyra_procesaPagoSEPA() {
        // COMPROBAMOS SI TENEMOS MARCADO EL CHECK DE ACEPTO LOS TERMINOS DEFINIDOS EN ESTE CONTRATO
        if (this.autorizo==true) {
          if (this.pagorec==true) {
            var prectot = parseInt(parseFloat(this.contrato.precio).toFixed(2)*100);
            var precstr = prectot.toString()
            this.lyra_vads_action_mode = "INTERACTIVE"
            this.lyra_vads_amount = this.pvp_web.replace(',','')
            this.lyra_vads_cust_email = this.contrato.email
            this.lyra_vads_cust_address = this.contrato.direccion
            this.lyra_vads_cust_cell_phone = this.contrato.telefono
            this.lyra_vads_cust_country = this.paisElegido
            this.lyra_vads_cust_first_name = this.contrato.nombre
            this.lyra_vads_cust_last_name = this.contrato.apellido1
            this.lyra_vads_page_action = "REGISTER_PAY"
            this.lyra_vads_payment_cards = "SDD"
            this.lyra_vads_trans_date = this.obtenerFechaHoraActual();
            this.lyra_vads_trans_id = await this.generarCodigoUnico();
            this.lyra_vads_order_id = uuidv4();
            this.lyra_vads_order_info = this.contrato.ref;
            this.lyra_vads_order_info2 = this.formatearFechaInicio(this.fechaInicio);
            this.lyra_vads_order_info3 = this.tiempoesp;
            this.lyra_vads_ext_info_ape1 = this.contrato.apellido1;
            this.lyra_vads_ext_info_ape2 = this.contrato.apellido2;
            this.lyra_vads_ext_info_nom = this.contrato.nombre;
            this.lyra_vads_ext_info_telefono = this.contrato.telefono;
            this.lyra_vads_ext_info_nif = this.contrato.nif;
            this.lyra_vads_ext_info_direccion = this.contrato.direccion;
            this.lyra_vads_ext_info_cp = this.contrato.cp;
            this.lyra_vads_ext_info_localidad = this.contrato.localidad;
            this.lyra_vads_ext_info_provincia = this.contrato.provincia;
            this.lyra_vads_ext_info_pais = this.paisElegido;
            this.lyra_vads_ext_info_centro = this.centroid;
            this.lyra_vads_ext_info_box = this.contrato.box;
            this.lyra_vads_ext_info_precio = this.contrato.precio;
            this.lyra_vads_ext_info_deposito = this.contrato.deposito;
            //this.lyra_vads_sub_desc = "RRULE:FREQ=MONTHLY;BYMONTHDAY=1"
            //this.lyra_vads_sub_effect_date = this.formatearFechaInicio(this.fechaInicio)
          } 
          await this.lyra_generaFirma_SEPA1();
          this.$refs.lyraPaymentForm3.submit();
        } else {
          this.aceptaterminos=true
        }
      },
      
      async lyra_generaFirma() {
          try {
              var params = new URLSearchParams();
              params.append('vads_action_mode', this.lyra_vads_action_mode);
              params.append('vads_amount', this.lyra_vads_amount);
              params.append('vads_ctx_mode', this.lyra_vads_ctx_mode);
              params.append('vads_currency', this.lyra_vads_currency);
              params.append('vads_page_action', this.lyra_vads_page_action);
              params.append('vads_payment_cards', this.lyra_vads_payment_cards);
              params.append('vads_payment_config', this.lyra_vads_payment_config);
              params.append('vads_site_id', this.lyra_vads_site_id);
              params.append('vads_trans_date', this.lyra_vads_trans_date);
              params.append('vads_trans_id', this.lyra_vads_trans_id);
              params.append('vads_version', this.lyra_vads_version);
              params.append('vads_cust_email', this.lyra_vads_cust_email);
              params.append('vads_order_id', this.lyra_vads_order_id);
              params.append('vads_order_info', this.lyra_vads_order_info);
              params.append('vads_order_info2', this.lyra_vads_order_info2);
              params.append('vads_order_info3', this.lyra_vads_order_info3);
              params.append('vads_ext_info_ape1', this.lyra_vads_ext_info_ape1)
              params.append('vads_ext_info_ape2', this.lyra_vads_ext_info_ape2)
              params.append('vads_ext_info_nom', this.lyra_vads_ext_info_nom)
              params.append('vads_ext_info_telefono', this.lyra_vads_ext_info_telefono)
              params.append('vads_ext_info_nif', this.lyra_vads_ext_info_nif)
              params.append('vads_ext_info_direccion', this.lyra_vads_ext_info_direccion)
              params.append('vads_ext_info_cp', this.lyra_vads_ext_info_cp)
              params.append('vads_ext_info_localidad', this.lyra_vads_ext_info_localidad)
              params.append('vads_ext_info_provincia', this.lyra_vads_ext_info_provincia)
              params.append('vads_ext_info_pais', this.lyra_vads_ext_info_pais)
              params.append('vads_ext_info_centro', this.lyra_vads_ext_info_centro)
              params.append('vads_ext_info_box', this.lyra_vads_ext_info_box)
              params.append('vads_ext_info_precio', this.lyra_vads_ext_info_precio)
              params.append('vads_ext_info_deposito', this.lyra_vads_ext_info_deposito)
              if (this.pagorec==true) {
                params.append('vads_sub_amount', this.lyra_vads_sub_amount);
                params.append('vads_sub_currency', this.lyra_vads_sub_currency);
                params.append('vads_sub_desc', this.lyra_vads_sub_desc);
                params.append('vads_sub_effect_date', this.lyra_vads_sub_effect_date);
              }

              const response = await axios.post(RUTA_PHP + 'lyrafirma.php', params);
              console.log(response.data);
              this.lyra_signature = response.data;
          } catch (error) {
              console.log(error);
          }
      },
      
      async lyra_generaFirma_SEPA1() {
          try {
            // Esto lo he comentado yo
              var params = new URLSearchParams();
              params.append('vads_action_mode', this.lyra_vads_action_mode);
              params.append('vads_amount', this.lyra_vads_amount);
              params.append('vads_ctx_mode', this.lyra_vads_ctx_mode);
              params.append('vads_currency', this.lyra_vads_currency);
              params.append('vads_cust_address', this.lyra_vads_cust_address);
              params.append('vads_cust_cell_phone', this.lyra_vads_cust_cell_phone);
              params.append('vads_cust_country', this.lyra_vads_cust_country);
              params.append('vads_cust_email', this.lyra_vads_cust_email);
              params.append('vads_cust_first_name', this.lyra_vads_cust_first_name);
              params.append('vads_cust_last_name', this.lyra_vads_cust_last_name);
              params.append('vads_ext_info_ape1', this.lyra_vads_ext_info_ape1)
              params.append('vads_ext_info_ape2', this.lyra_vads_ext_info_ape2)
              params.append('vads_ext_info_cp', this.lyra_vads_ext_info_cp)
              params.append('vads_ext_info_direccion', this.lyra_vads_ext_info_direccion)
              params.append('vads_ext_info_localidad', this.lyra_vads_ext_info_localidad)
              params.append('vads_ext_info_nif', this.lyra_vads_ext_info_nif)
              params.append('vads_ext_info_nom', this.lyra_vads_ext_info_nom)
              params.append('vads_ext_info_provincia', this.lyra_vads_ext_info_provincia)
              params.append('vads_ext_info_pais', this.lyra_vads_ext_info_pais)
              params.append('vads_ext_info_centro', this.lyra_vads_ext_info_centro)
              params.append('vads_ext_info_box', this.lyra_vads_ext_info_box)
              params.append('vads_ext_info_precio', this.lyra_vads_ext_info_precio)
              params.append('vads_ext_info_deposito', this.lyra_vads_ext_info_deposito)
              params.append('vads_ext_info_telefono', this.lyra_vads_ext_info_telefono)
              params.append('vads_order_id', this.lyra_vads_order_id);
              params.append('vads_order_info', this.lyra_vads_order_info);
              params.append('vads_order_info2', this.lyra_vads_order_info2);
              params.append('vads_order_info3', this.lyra_vads_order_info3);
              params.append('vads_page_action', this.lyra_vads_page_action);
              params.append('vads_payment_cards', this.lyra_vads_payment_cards);
              params.append('vads_payment_config', this.lyra_vads_payment_config);
              params.append('vads_site_id', this.lyra_vads_site_id);
              params.append('vads_trans_date', this.lyra_vads_trans_date);
              params.append('vads_trans_id', this.lyra_vads_trans_id);
              params.append('vads_version', this.lyra_vads_version);
              const response = await axios.post(RUTA_PHP + 'lyrafirma.php', params);
              //console.log(response.data);
              this.lyra_signature = response.data;
          } catch (error) {
              console.log(error);
          }
      },
      
      formatearFechaInicio(fecha) {
        // Convertir la cadena a un objeto Date si es necesario
        if (typeof fecha === 'string') {
          fecha = new Date(fecha);
        }
      
        const anio = fecha.getUTCFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        return `${anio}${mes}${dia}`;
      },
      
      obtenerFechaHoraActual() {
          const fechaActual = new Date();
          // LA CONVERTIMOS A FORMATO UTC (UNIVERSAL TIME COORDINATED) POR EXIGENCIAS DE LA PLATAFORMA
          const anio = fechaActual.getUTCFullYear();
          const mes = String(fechaActual.getUTCMonth() + 1).padStart(2, '0'); // En JavaScript, el mes inicia en 0
          const dia = String(fechaActual.getUTCDate()).padStart(2, '0');
          const hora = String(fechaActual.getUTCHours()).padStart(2, '0');
          const minuto = String(fechaActual.getUTCMinutes()).padStart(2, '0');
          const segundo = String(fechaActual.getUTCSeconds()).padStart(2, '0');
          
          return `${anio}${mes}${dia}${hora}${minuto}${segundo}`;
      },
      
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`; // Formato ISO 8601 para fecha
      },
      
      async generarCodigoUnico() {
        const fechaActual = new Date();
        
        const anio = fechaActual.getFullYear();
        const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
        const dia = String(fechaActual.getDate()).padStart(2, '0');
        const hora = String(fechaActual.getHours()).padStart(2, '0');
        const minuto = String(fechaActual.getMinutes()).padStart(2, '0');
        const segundo = String(fechaActual.getSeconds()).padStart(2, '0');
        
        // Añade un valor aleatorio para reducir la posibilidad de colisiones
        const randomValue = Math.floor(Math.random() * 1000);  // Un valor entre 0 y 999
        
        const inputStr = `${anio}${mes}${dia}${hora}${minuto}${segundo}${randomValue}`;
        
        // Genera el hash usando la API de Web Crypto
        const msgUint8 = new TextEncoder().encode(inputStr); // codifica como (utf-8) Uint8Array
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convierte el buffer a byte array
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convierte los bytes a hexadecimal
        
        // Toma solo los primeros 6 caracteres del hash
        return hashHex.substring(0, 6).toUpperCase(); // El toUpperCase() es opcional, pero ayuda a estandarizar el formato
      },
      
      eligeCentro(centro) {

        this.tamelegido = false;
        this.elemelegido = false;
        this.elegido = false;
        this.boxelegido = false;
        this.boxesfilt = [];
        this.tamvalor = '';
        this.plantavalor = '';
        this.elemobj = {};

        this.centrosel = centro
        this.centroid = centro.id
        this.$store.state.centro_pasarela = centro.id
        console.log("centro: ",centro)
        console.log("centroID: ",this.centroid)
        
        var params = new URLSearchParams()
        params.append('centro', this.centroid)
        axios.post(RUTA_PHP+'dameboxescentro.php',params)
        .then(response => {
            console.log('dameboxescentro.php: ',response.data)
            this.medidas = response.data[0].TIP_WEB
            this.medidas.forEach(med => {
              med.ESP_PAR = med.ESP_PAR.replace(" euros","€")
              med.visible = true
              med.showimg = false
            })
            this.tiempoespacio = response.data[0].PER_WEB
            this.tiempoespacio.forEach(per => {
              per.PER_WEB = per.tiempoespacio
            })
          
            this.plantaseleccion = response.data[0].PLANTA
            this.plantaseleccion.forEach(pln => {
              pln.PER_WEB = pln.plantaseleccion
            })
            console.log('promociones:', this.tiempoespacio)
            console.log('plantas: ',this.plantaseleccion)
            console.log('medidas: ',this.medidas)
            this.plantas = response.data[0].PLANTA
            
            this.boxes = response.data[0].BOX
            this.boxes.forEach(box => {
              box.total = (box.IMP_DEP+box.PVP_CON_IVA).toFixed(2)
            })
        })
        .catch(error => console.log(error))
      },
      nextStep() {
        if (this.activeStep < 2) { // Reemplaza '2' con el número total de pasos - 1
          if (this.activeStep > 0) {
            if (this.controlarCheck == true) {
              var params = new URLSearchParams()
              params.append('centro', this.centroid)
              params.append('nombre', this.contrato.nombre)
              params.append('apellido1', this.contrato.apellido1)
              params.append('apellido2', this.contrato.apellido2)
              params.append('telefono', this.contrato.telefono)
              params.append('email', this.contrato.email)
              params.append('direccion', this.contrato.direccion)
              params.append('cp', this.contrato.cp)
              params.append('localidad', this.contrato.localidad)
              params.append('provincia', this.contrato.provincia)
              params.append('pais', this.paisElegido)
              params.append('comentario', 'B_TIP_WEB_BOX: '+this.boxesfilt[0].B_TIP_WEB_BOX)
              axios.post(RUTA_PHP+'tomacrm.php',params)
              .then(response => {
                  console.log('tomacrm.php: ',response.data)
              })
              .catch(error => console.log(error))
            } else{
              alert("Tienes que aceptar el consentimiento de datos.");
            }
          }  
          this.activeStep++; 
        }
      },
      previousStep() {
        if (this.activeStep > 0) {
          this.controlarCheck = true;
          this.activeStep--;
        }
      },
      
      nombrePlanta(id) {
        const planta = this.plantas.find(function(planta) {
          return planta.ID == id;
        });
        return planta ? planta.NAME : id;
      },

      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/contratar'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.mensajes
          this.ventajas = response.data.ventajas
          this.centros = response.data.centros
          this.tiposespacio = response.data.tiposespacio
          this.tiempoespacio = response.data.tiempoespacio
          this.motivoespacio = response.data.motivoesp
          this.fuenteespacio = response.data.fuenteespacio
          this.tipo_texto.linea1.value = response.data.tipo_texto

          this.$set(this, 'tipo_texto', response.data.tipo_texto);
          
          this.errornombre = this.mensaje('men60')
          this.errorape1 = this.mensaje('men60')
          this.errornif = this.mensaje('men60')
          this.erroremail = this.mensaje('men60')
          this.errortelefono = this.mensaje('men60')
          this.errordireccion = this.mensaje('men60')
        })
        .catch(error => console.log(error))
      },
      previewFile(event) {
        console.log("evento: ",event)
        console.log("fichero: ", event.target.files[0])
        let imagen = event.target.files[0]
        this.createBase64Image(imagen)
        
      },
      createBase64Image(fileObject) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.dniimagen = e.target.result
          console.log("dniimagen: ",this.dniimagen)
        }
        reader.readAsDataURL(fileObject)
        
      },

      previewFile2(event) {
        console.log("evento: ",event)
        console.log("fichero: ", event.target.files[0])
        let imagen = event.target.files[0]
        this.createBase64Image2(imagen)
        
      },
      createBase64Image2(fileObject) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.dniimagen2 = e.target.result
          console.log("dniimagen2: ",this.dniimagen2)
        }
        reader.readAsDataURL(fileObject)
        
      },
      
      minusculas(){
        this.contrato.email = this.contrato.email.toLowerCase();
      },

      chooseFiles() {
          let fileInputElement = this.$refs.fileUpload
          fileInputElement.click()
      },
      chooseFiles2() {
          let fileInputElement = this.$refs.fileUpload2
          fileInputElement.click()
      },
      onLoaded(opc) {
        //console.log("Loade: ",opc)
        opc.showimg = true
      },
      controlanombre() {
        if (this.contrato.nombre.length>0) {
          this.errornombre=''
        } else {
          this.errornombre=this.mensaje('men60')
        }
      },
      controlaape1() {
        if (this.contrato.apellido1.length>0) {
          this.errorape1=''
        } else {
          this.errorape1=this.mensaje('men60')
        }
      },
      controlatelefono() {
        if (this.contrato.telefono.length>0) {
          this.errortelefono=''
        } else {
          this.errortelefono=this.mensaje('men60')
        }
      },
      controladireccion() {
        if (this.contrato.direccion.length>0) {
          this.errordireccion=''
        } else {
          this.errordireccion=this.mensaje('men60')
        }
      },
      controlapellido2() {
        if (!this.apellido2Obligatorio || this.contrato.apellido2.length>0) {
          this.errorapellido2=''
        } else {
          this.errorapellido2=this.mensaje('men60')
        }
      },
      controlacp() {
        if (!this.cpObligatorio || this.contrato.cp.length>4) {
          this.errorcp=''
        } else {
          this.errorcp=this.mensaje('men60')
        }
      },
      controlalocalidad() {
        if (!this.localidadObligatorio || this.contrato.localidad.length>0) {
          this.errorlocalidad=''
        } else {
          this.errorlocalidad=this.mensaje('men60')
        }
      },
      controlaprovincia() {
        if (!this.provinciaObligatorio || this.contrato.provincia.length>0) {
          this.errorprovincia=''
        } else {
          this.errorprovincia=this.mensaje('men60')
        }
      },
      controlanif() {
        if (this.controlar_NIF) {
          if (esNifNieValido(this.contrato.nif)) {
            this.errornif=''
          } else {
            this.errornif=this.mensaje('men146')
          }
        } else {
          if (this.contrato.nif.length>0) {
            this.errornif=''
          } else {
            this.errornif=this.mensaje('men60')
          }
        }
      },
      controlaemail() {
        if (this.contrato.email.length>0) {
          this.erroremail=''
        } else {
          this.erroremail=this.mensaje('men60')
        }
      },
      controlaiban() {
        if ((this.contrato.iban.length>3 && this.contrato.iban.length<5)||this.contrato.iban.length==0) {
          this.ibanclass="has-success"
          this.erroriban=""
        } else {
          this.ibanclass="has-danger"
          this.erroriban="4 "+this.mensaje('men61')
        }
      },
      controlaentidad() {
        if ((this.contrato.entidad.length>3 && this.contrato.entidad.length<5)||this.contrato.entidad.length==0) {
          this.entidclass="has-success"
          this.errorentidad=""
        } else {
          this.entidclass="has-danger"
          this.errorentidad="4 "+this.mensaje('men61')
        }
      },
      controlaoficina() {
        if ((this.contrato.oficina.length>3 && this.contrato.oficina.length<5)||this.contrato.oficina.length==0) {
          this.oficinaclass="has-success"
          this.erroroficina=""
        } else {
          this.oficinaclass="has-danger"
          this.erroroficina="4 "+this.mensaje('men61')
        }
      },
      controladc() {
        if ((this.contrato.dc.length>1 && this.contrato.dc.length<3)||this.contrato.dc.length==0) {
          this.dcclass="has-success"
          this.errordc=""
        } else {
          this.dcclass="has-danger"
          this.errordc="2 "+this.mensaje('men61')
        }
      },
      controlacuenta() {
        if ((this.contrato.cuenta.length>9 && this.contrato.cuenta.length<11)||this.contrato.cuenta.length==0) {
          this.cuentaclass="has-success"
          this.errorcuenta=""
        } else {
          this.cuentaclass="has-danger"
          this.errorcuenta="10 "+this.mensaje('men61')
        }
      },
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      },
      volver() {
        this.elegido = false
        this.tamelegido = false
        this.elemelegido = false
        this.boxesfilt = []
        this.plantasfilt = []
        this.plantavalor = ''
        this.tamvalor = ''
        this.medidas.forEach(med => {
          if (med.TIP == this.tipoesp) {
            med.visible = true
          } else {
            med.visible = false
          }
        })        
        
      },
      volver2() {
        this.elegido = false
        this.tamelegido = true
        this.elemelegido = false
        this.boxelegido = false
        this.boxesfilt = [] 
        var selfboxes = this.boxesfilt
        var tam = this.tamvalor
        this.medidas.forEach(med => {
          if (med.ID == tam) {
            med.visible = true
          } else {
            med.visible = false
          }
          
        })
        
        this.boxes.forEach(box => {
          if (box.B_TIP_WEB_BOX==tam) {
            selfboxes.push(box)
          }
        })      
        
      },
      eligetam(tam) {
        this.tamvalor = tam
        this.elegido = false
        this.tamelegido = true
        this.plantasfilt = []
        this.boxesfilt = []
        this.plantavalor = ''
        var selfboxes = this.boxesfilt
        this.medidas.forEach(med => {
          if (med.ID == tam) {
            med.visible = true
          } else {
            med.visible = false
          }
          
        })
        this.boxes.forEach(box => {
          if (box.B_TIP_WEB_BOX==tam) {
            selfboxes.push(box)
          }
        })
        console.log("boxesfilt: ",this.boxesfilt)
      },
      contratar(elem) {
        this.elemobj = elem
        console.log("elem: ",elem)
        this.elegido = true
        this.elemelegido = true
        this.contrato.box = elem.ID
        this.contrato.ref = elem.REF
        this.contrato.precio = (elem.PVP_CON_IVA).toFixed(2)
        this.contrato.deposito = elem.IMP_DEP.toFixed(2)
        this.boxelegido = false
        
        console.log("centro: ",this.centroid)
        console.log("fechaInicio: ",this.formatearFechaInicio(this.fechaInicio))
        console.log("refbox: ",this.contrato.ref)
        console.log("idbox: ",this.contrato.box)
        console.log("tiempo: ",this.tiempoesp)
        var params = new URLSearchParams()
        params.append('centro', this.centroid)
        params.append('fecha', this.formatearFechaInicio(this.fechaInicio))
        params.append('idbox', this.contrato.box)
        params.append('tiempo', this.tiempoesp)
        axios.post(RUTA_PHP+'dameboxprecio.php',params)
        .then(response => {
            console.log('dameboxprecio.php: ',response.data)
            
            this.dias_web = String(response.data[0].PAGO[0].DIAS_WEB)
            this.dto_web = String(response.data[0].PAGO[0].DTO_WEB)
            var vImpDep = response.data[0].PAGO[0].IMP_DEP
            this.imp_dep = String(vImpDep).replace('.',',')
            var vPVPConIVA = response.data[0].PAGO[0].PVP_CON_IVA_PROX_WEB
            this.pvp_con_iva = String(vPVPConIVA).replace('.',',')
            var vPVPDia = response.data[0].PAGO[0].PVP_DIA
            this.pvp_dia = String(vPVPDia).replace('.',',')
            var vPVPMen = response.data[0].PAGO[0].PVP_MEN
            this.pvp_men = String(vPVPMen).replace('.',',')
            var vPVPWeb = response.data[0].PAGO[0].PVP_WEB
            this.pvp_web = String(vPVPWeb).replace('.',',')
            this.imp_dep = response.data[0].PAGO[0].DEP_WEB
            this.refbox = this.contrato.ref;
            
            var fechaDsdWeb = response.data[0].PAGO[0].FCH_DSD_WEB
            var fechaDsdWebTrans = fechaDsdWeb.split('-').reverse().join('/')
            this.fch_dsd_web = fechaDsdWebTrans
            
            var fechaHstWeb = response.data[0].PAGO[0].FCH_HST_WEB
            var fechaHstWebTrans = fechaHstWeb.split('-').reverse().join('/')
            this.fch_hst_web = fechaHstWebTrans
            
            var fechaProPagWeb = response.data[0].PAGO[0].FCH_PRO_PAG_WEB
            var fechaProPagWebTrans = fechaProPagWeb.split('-').reverse().join('/')
            this.fch_pro_pag_web = fechaProPagWebTrans

            console.log('this.dias_web: ',this.dias_web)
            console.log('this.dto_web: ',this.dto_web)
            console.log('this.imp_dep: ',this.imp_dep)
            console.log('this.pvp_con_iva: ',this.pvp_con_iva)
            console.log('this.pvp_dia: ',this.pvp_dia)
            console.log('this.pvp_men: ',this.pvp_men)
            console.log('this.pvp_web: ',this.pvp_web)
            
            this.boxelegido = true
            
            //this.medidas = response.data[0].TIP_WEB
        })
        .catch(error => console.log(error))
        
        this.boxesfilt = []
        var tam = this.tamvalor
        var selfboxes = this.boxesfilt
        this.boxes.forEach(box => {
          if (box.ID==elem.ID) {
            selfboxes.push(box)
          }
        })
      },
      
      recalcular(elem) {
        if (Object.keys(elem).length > 0) {
          console.log("RECALCULO")
          var params = new URLSearchParams()
          params.append('centro', this.centroid)
          params.append('fecha', this.formatearFechaInicio(this.fechaInicio))
          params.append('idbox', this.contrato.box)
          params.append('tiempo', this.tiempoesp)
          axios.post(RUTA_PHP+'dameboxprecio.php',params)
          .then(response => {
              this.dias_web = String(response.data[0].PAGO[0].DIAS_WEB)
              this.dto_web = String(response.data[0].PAGO[0].DTO_WEB)
              var vImpDep = response.data[0].PAGO[0].IMP_DEP
              this.imp_dep = String(vImpDep).replace('.',',')
              var vPVPConIVA = response.data[0].PAGO[0].PVP_CON_IVA_PROX_WEB
              this.pvp_con_iva = String(vPVPConIVA).replace('.',',')
              var vPVPDia = response.data[0].PAGO[0].PVP_DIA
              this.pvp_dia = String(vPVPDia).replace('.',',')
              var vPVPMen = response.data[0].PAGO[0].PVP_MEN
              this.pvp_men = String(vPVPMen).replace('.',',')
              var vPVPWeb = response.data[0].PAGO[0].PVP_WEB
              this.pvp_web = String(vPVPWeb).replace('.',',')
              this.imp_dep = response.data[0].PAGO[0].DEP_WEB
              this.refbox = this.contrato.ref;
              
              var fechaDsdWeb = response.data[0].PAGO[0].FCH_DSD_WEB
              var fechaDsdWebTrans = fechaDsdWeb.split('-').reverse().join('/')
              this.fch_dsd_web = fechaDsdWebTrans
              
              var fechaHstWeb = response.data[0].PAGO[0].FCH_HST_WEB
              var fechaHstWebTrans = fechaHstWeb.split('-').reverse().join('/')
              this.fch_hst_web = fechaHstWebTrans
              
              var fechaProPagWeb = response.data[0].PAGO[0].FCH_PRO_PAG_WEB
              var fechaProPagWebTrans = fechaProPagWeb.split('-').reverse().join('/')
              this.fch_pro_pag_web = fechaProPagWebTrans
          })
          .catch(error => console.log(error))
        }
        
      },
      
      enviacontrato() {
        var nifvalido = false
        if (this.controlar_NIF) {
          if (esNifNieValido(this.contrato.nif)) {
            nifvalido = true
          }
        } else {
          if (this.contrato.nif.length>0) {
            nifvalido = true
          }
        }
        
        if (this.contrato.nombre=="" || this.contrato.apellido1=="" || nifvalido==false || this.contrato.email=="" || this.contrato.telefono=="" || this.contrato.direccion=="") {
          this.faltancampos=true
        } else {
          this.faltancampos=false
        }
        
        if (this.pagopasarela==true) {
          if (this.faltancampos==false) {
            if (this.autorizo==true) {
              console.log('pagorec: ',this.pagorec)
              if (this.pagorec==true) {
                var precstr = this.pvp_web.replace(',','')
                
                //var prectot = parseInt(parseFloat(this.contrato.precio).toFixed(2)*100);
                //var precstr = prectot.toString()
                // GENERAMOS EL PAGO AUTORIZANDO FUTUROS PAGOS RECURRENTES
                var oRef = {
                  "CENTRO": this.$store.state.centro_pasarela,
                  "NOMBRE": this.contrato.nombre,
                  "APELLIDO1": this.contrato.apellido1,
                  "APELLIDO2": this.contrato.apellido2,
                  "TELEFONO": this.contrato.telefono,
                  "EMAIL": this.contrato.email,
                  "CP": this.contrato.cp,
                  "NIF": this.contrato.nif,
                  "DIRECCION": this.contrato.direccion,
                  "LOCALIDAD": this.contrato.localidad,
                  "PROVINCIA": this.contrato.provincia,
                  "IBAN": this.contrato.iban,
                  "ENTIDAD": this.contrato.entidad,
                  "OFICINA": this.contrato.oficina,
                  "DC": this.contrato.dc,
                  "CUENTA": this.contrato.cuenta,
                  "BOX": this.contrato.box,
                  "REF": this.contrato.ref,
                  "PRECIO": this.pvp_web.replace(',','.'),
                  "DEPOSITO": this.imp_dep.replace(',','.'),
                  "MOTIVO": this.valorMotivo,
                  "FUENTE": this.valorFuente,
                  "ORIGEN": this.contrato.origen,
                  "FINICIO": this.fechaInicio,
                  "FP": this.fp
                }
                console.log("oRef: ",oRef)
                var merData = JSON.stringify(oRef)
                console.log("merData: ",merData)
                var ord2 = getRandomInt(100,999).toString(36)+getId()  // hasta 12 dígitos alfanuméricos
                //console.log("ord2: ",ord2)
                //var impo = this.contrato.precio
                //var impo2 = impo.replace(".","")
                //console.log("impo2: ",impo2)
                
                var ruta_redsys = "";
                if (this.centrosel.redsys_pruebas == true) {
                  ruta_redsys = this.$store.state.ruta_pasarela_banco_pruebas;
                } else {
                  ruta_redsys = this.$store.state.ruta_pasarela_banco;
                }
                
                var params = new URLSearchParams()
                params.append('order', ord2)
                params.append('importe', precstr)
                params.append('merdata', merData)
                //params.append('centro', this.$store.state.centro_pasarela)
                params.append('centro', this.centroid)
                params.append('usuario', "")
                params.append('dni1', this.dniimagen)
                params.append('dni2', this.dniimagen2)
                params.append('email', this.contrato.email)
                axios.post(RUTA_PHP+'pasarela_contrato_autoriz.php', params)
                .then((respuesta) => {
                  // Crea formulario
                  var mapForm = document.createElement("form");
                  //mapForm.target = "_blank"; 
                  mapForm.target = "_self";   
                  mapForm.method = "POST";
                  mapForm.action = ruta_redsys;
                  // Crea un input
                  var mapInput = document.createElement("input");
                  mapInput.type = "hidden";
                  mapInput.name = "Ds_SignatureVersion";
                  mapInput.value = "HMAC_SHA256_V1";
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput);
                  // Crea un input
                  var mapInput2 = document.createElement("input");
                  mapInput2.type = "hidden";
                  mapInput2.name = "Ds_MerchantParameters";
                  mapInput2.value = respuesta.data.params;
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput2);
                  // Crea un input
                  var mapInput3 = document.createElement("input");
                  mapInput3.type = "hidden";
                  mapInput3.name = "Ds_Signature";
                  mapInput3.value = respuesta.data.signature;
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput3);
                  // Añade el formulario al dom
                  document.body.appendChild(mapForm);
                  // Hace el submit del formulario
                  mapForm.submit();
                })
                .catch((error) => {
                   console.log('error: ',error)
                });
  
              } else {
                var precstr = this.pvp_web.replace(',','')
                //var prectot = parseInt(parseFloat(this.contrato.precio).toFixed(2)*100);
                //var precstr = prectot.toString()
                // GENERAMOS SOLO EL PAGO DE ESTA RESERVA
                var oRef = {
                  "CENTRO": this.$store.state.centro_pasarela,
                  "NOMBRE": this.contrato.nombre,
                  "APELLIDO1": this.contrato.apellido1,
                  "APELLIDO2": this.contrato.apellido2,
                  "TELEFONO": this.contrato.telefono,
                  "EMAIL": this.contrato.email,
                  "CP": this.contrato.cp,
                  "NIF": this.contrato.nif,
                  "DIRECCION": this.contrato.direccion,
                  "LOCALIDAD": this.contrato.localidad,
                  "PROVINCIA": this.contrato.provincia,
                  "IBAN": this.contrato.iban,
                  "ENTIDAD": this.contrato.entidad,
                  "OFICINA": this.contrato.oficina,
                  "DC": this.contrato.dc,
                  "CUENTA": this.contrato.cuenta,
                  "BOX": this.contrato.box,
                  "REF": refbox,
                  "PRECIO": this.pvp_web.replace(',','.'),
                  "DEPOSITO": this.imp_dep.replace(',','.'),
                  "MOTIVO": this.valorMotivo,
                  "FUENTE": this.valorFuente,
                  "ORIGEN": this.contrato.origen,
                  "FINICIO": this.fechaInicio,
                  "FP": this.fp
                }
                console.log("oRef: ",oRef)
                var merData = JSON.stringify(oRef)
                console.log("merData: ",merData)
                var ord2 = getRandomInt(100,999).toString(36)+getId()  // hasta 12 dígitos alfanuméricos
                console.log("ord2: ",ord2)
                //var impo = this.contrato.precio
                //var impo2 = impo.replace(".","")
                //console.log("impo2: ",impo2)
                
                var ruta_redsys = "";
                if (this.centrosel.redsys_pruebas == true) {
                  ruta_redsys = this.$store.state.ruta_pasarela_banco_pruebas;
                } else {
                  ruta_redsys = this.$store.state.ruta_pasarela_banco;
                }
                
                var params = new URLSearchParams()
                params.append('order', ord2)
                params.append('importe', precstr)
                params.append('merdata', merData)
                params.append('centro', this.centroid)
                params.append('usuario', "")
                params.append('dni1', this.dniimagen)
                params.append('dni2', this.dniimagen2)
                params.append('email', this.contrato.email)
                axios.post(RUTA_PHP+'pasarela_contrato.php', params)
                .then((respuesta) => {
                  // Crea formulario
                  var mapForm = document.createElement("form");
                  //mapForm.target = "_blank"; 
                  mapForm.target = "_self";   
                  mapForm.method = "POST";
                  mapForm.action = ruta_redsys;
                  // Crea un input
                  var mapInput = document.createElement("input");
                  mapInput.type = "hidden";
                  mapInput.name = "Ds_SignatureVersion";
                  mapInput.value = "HMAC_SHA256_V1";
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput);
                  // Crea un input
                  var mapInput2 = document.createElement("input");
                  mapInput2.type = "hidden";
                  mapInput2.name = "Ds_MerchantParameters";
                  mapInput2.value = respuesta.data.params;
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput2);
                  // Crea un input
                  var mapInput3 = document.createElement("input");
                  mapInput3.type = "hidden";
                  mapInput3.name = "Ds_Signature";
                  mapInput3.value = respuesta.data.signature;
                  // Añade el input al formulario
                  mapForm.appendChild(mapInput3);
                  // Añade el formulario al dom
                  document.body.appendChild(mapForm);
                  // Hace el submit del formulario
                  mapForm.submit();
                })
                .catch((error) => {
                   console.log('error: ',error)
                });
              }  
            } else {
              this.aceptaterminos=true
            }
          }
          
        }
        else {
          var params = new URLSearchParams()
          params.append('nombre',this.contrato.nombre)
          params.append('ape1',this.contrato.apellido1)
          params.append('ape2',this.contrato.apellido2)
          params.append('telefono', this.contrato.telefono)
          params.append('email', this.contrato.email)
          params.append('cp', this.contrato.cp)
          params.append('nif', this.contrato.nif)
          params.append('direccion', this.contrato.direccion)
          params.append('localidad', this.contrato.localidad)
          params.append('provincia', this.contrato.provincia)
          params.append('fp', this.contrato.fp)
          params.append('iban', this.contrato.iban)
          params.append('entidad', this.contrato.entidad)
          params.append('oficina', this.contrato.oficina)
          params.append('dc', this.contrato.dc)
          params.append('cuenta', this.contrato.cuenta)
          params.append('box', this.contrato.box)
          params.append('ref', this.contrato.ref)
          params.append('origen', this.contrato.origen)
          params.append('total', this.pvp_web)
          params.append('deposito', this.imp_dep)
          params.append('centro', this.centroid)
          axios.post(RUTA_PHP+'tomacontrato.php', params)
          .then((respuesta) => {
              if (typeof respuesta.data !== 'undefined' && respuesta.data.length > 0) {
                var resp = respuesta.data
                console.log(resp)
                if (resp.includes("CORRECTO")) {
                  console.log('correcto')
                  this.dialogVisible = true
                  this.$router.push('/principal')
                }
              }
          });
        }
      },
      inicializarValidaciones() {
        if (this.apellido2Obligatorio && !this.contrato.apellido2) {
          this.errorapellido2 = this.mensaje('men60');
        }
        if (this.cpObligatorio && !this.contrato.cp) {
          this.errorcp = this.mensaje('men60');
        }
        if (this.localidadObligatorio && !this.contrato.localidad) {
          this.errorlocalidad = this.mensaje('men60');
        }
        if (this.provinciaObligatorio && !this.contrato.provincia) {
          this.errorprovincia = this.mensaje('men60');
        }


      },
      
      idioma() {
        var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
        var cadJson = 'json/contratar'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          console.log("data: ",response.data)
            this.mensajes = response.data.mensajes
            this.ventajas = response.data.ventajas
            this.centros = response.data.centros
            this.tiposespacio = response.data.tiposespacio
            this.tiempoespacio = response.data.tiempoespacio
            this.motivoespacio = response.data.motivoesp
            this.fuenteespacio = response.data.fuenteespacio
            this.paises = response.data.paises
            this.tipo_texto = response.data.tipo_texto

            console.log("pruebaLetraNegrita: " + response.data.tipo_texto);
            
            if (this.centros.length==1) {
              this.eligeCentro(this.centros[0])
            }
            if (this.tiempoespacio.length==1) {
              this.tiempoesp = this.tiempoespacio[0].ID
            }
            if (this.tiposespacio.length==1) {
              this.tipoesp = this.tiposespacio[0].label
              this.tipoespCambia(this.tipoesp)
            }
            
            
            this.errornombre = this.mensaje('men60')
            this.errorape1 = this.mensaje('men60')
            this.errornif = this.mensaje('men60')
            this.erroremail = this.mensaje('men60')
            this.errortelefono = this.mensaje('men60')
            this.errordireccion = this.mensaje('men60')
            
            // Comprobar el estado del pago y mostrar la notificación correspondiente
            if (this.pago === 'ok') {
              Notification.info({
                title: this.mensaje('men149'),
                message: this.mensaje('men147'),
                duration: 0
              });
            } else if (this.pago === 'ko') {
              Notification.error({
                title: this.mensaje('men150'),
                message: this.mensaje('men148'),
                duration: 0
              });
            }
            
            this.inicializarValidaciones()
            
        
        })
        .catch(error => console.log(error))
      }
      
    },
    created() {
      
    },
    computed: {
      esNifValido() {
        var nifvalido = false
        if (this.controlar_NIF) {
          if (esNifNieValido(this.contrato.nif)) {
            nifvalido = true
          }
        } else {
          if (this.contrato.nif.length>0) {
            nifvalido = true
          }
        }
        return nifvalido
      },

      rangoMes() {
        if (!this.fechaInicio) return '';
        const inicio = new Date(this.fechaInicio);
        const fin = new Date(inicio.getFullYear(), inicio.getMonth() + 1, 0);
        // Formato dd/mm/yyyy
        const inicioStr = inicio.toLocaleDateString();
        const finStr = fin.toLocaleDateString();
        return `Desde ${inicioStr} Hasta ${finStr})`;
      },

      metrosCuadradosTexto() {
    if (
      this.tipoElemento === 'Selecciona la referencia de tamaño' ||
      this.cantidadSeleccionada === 'Selecciona la cantidad'
    ) {
      return '';
    }

        // Mapas para cada tipo
        const mapas = {
          Furgonetas: {
            '0,3': '1,5M²',
            '0,5': '2,5M²',
            '1': '4,5M²',
            '1,5': '7M²',
            '2': '9M²'
          },
          Cajas: {
            '25': '1,5M²',
            '50': '2M²',
            '75': '2,5M²',
            '100': '3,5M²',
            '150': '5M²'
          },
          Habitaciones: {
            'Estudio': '3M²',
            '1': '4,5M²',
            '2': '6M²',
            '3': '8M²',
            '4': '10,5M²'
          },
          Archivos: {
            '100': '1,5M²',
            '250': '3M²',
            '500': '5,5M²',
            '1000': '11,5M²',
            '2000': '23M²'
          },
          Contenedores: {
            '0,3': '5M²',
            '0,5': '8M²',
            '1': '16M²',
            '1,5': '24M²',
            '2': '32M²'
          }
        };

        const mapa = mapas[this.tipoElemento];
        if (mapa && mapa[this.cantidadSeleccionada]) {
          return mapa[this.cantidadSeleccionada];
        }
        return '';
      }
      
    },

    
    
    mounted() {

      console.log("Environment: ",process.env.NODE_ENV)
      if (process.env.NODE_ENV=="development") {
        this.desarrollo = true;
      }
      
      this.logo_altura = this.$store.state.logo_altura
      console.log("logo_altura: ",this.logo_altura)
      this.sincuentabanco = this.$store.state.sin_cuenta_banco
      this.sindni = this.$store.state.sin_dni
      this.pagopasarela = this.$store.state.pago_pasarela
      this.tipopasarela = this.$store.state.tipo_pasarela
      this.controlar_NIF = this.$store.state.controlar_NIF
      this.apellido2Obligatorio = this.$store.state.apellido2_obligatorio
      this.cpObligatorio = this.$store.state.cp_obligatorio
      this.localidadObligatorio = this.$store.state.localidad_obligatorio
      this.provinciaObligatorio = this.$store.state.provincia_obligatorio
      this.isDatePickerDisabled = this.$store.state.fecha_inicio_deshabilitada
      this.headerSimple = this.$store.state.header_simple
      this.pagopasarela = this.$store.state.pago_pasarela
      console.log ("pago pasarela: ", this.pagopasarela)
      
      console.log("TIPOESP: ",this.tipoesp)
      axios.get(RUTA_PHP+'dameboxes.php')
      .then(response => {
          console.log('dameboxes.php: ',response.data)
          
          this.medidas = response.data[0].TIP_WEB
          this.medidas.forEach(med => {
            med.visible = true
            med.showimg = false
          })
          
          console.log('medidas: ',this.medidas)
          this.plantas = response.data[0].PLANTA

          this.boxes = response.data[0].BOX
          this.boxes.forEach(box => {
            box.total = (box.IMP_DEP+box.PVP_CON_IVA).toFixed(2)
          })
          
          this.idioma()
      })
      .catch(error => console.log(error))

      
    }
  }
  
  function miorden() {
    var fecha = new Date()
    var ano = fecha.getFullYear()
    var mes = fecha.getMonth()+1
    var dia = fecha.getDate()
    var h = fecha.getHours()
    var m = fecha.getMinutes()
    var s = fecha.getSeconds()
    var o = ano.toString().substring(2,4)+mes.toString()+dia.toString()+h.toString()+m.toString()+s.toString()
    return o
  }
  
  function getId() {
    //var newTime = parseInt(moment().format("X")) - 1546300800;//seconds since 01/01/2019
    var newTime = Math.floor((new Date()).getTime() / 1000) - 1546300800;//seconds since 01/01/2019
    return newTime.toString(36);
  }
  
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }
  
  
  function esNifNieValido(identificador) {
      const patronNif = /^[0-9]{8}[A-Z]$/i;
      const patronNie = /^[XYZ][0-9]{7}[A-Z]$/i;
      const patronCif = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/i;
      const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
      const serieNumerica = "JABCDEFGHI";
  
      identificador = identificador.trim().toUpperCase();
  
      // NIF
      if (patronNif.test(identificador)) {
          const numero = parseInt(identificador.substring(0, 8));
          const letraCorrecta = letrasValidas.charAt(numero % 23);
          return letraCorrecta === identificador.charAt(8);
      } 
      // NIE
      else if (patronNie.test(identificador)) {
          const numero = parseInt("0" + identificador.substring(1, 8), 10);
          const letraInicial = identificador.charAt(0);
          const indiceLetraInicial = letraInicial === 'X' ? 0 : letraInicial === 'Y' ? 1 : 2;
          const letraCorrecta = letrasValidas.charAt((numero + indiceLetraInicial * 10000000) % 23);
          return letraCorrecta === identificador.charAt(8);
      } 
      // CIF
      else if (patronCif.test(identificador)) {
          const digitos = identificador.substring(1, 8);
          let sumaPar = 0;
          let sumaImpar = 0;
          for (let i = 0; i < digitos.length; i++) {
              const numero = parseInt(digitos.charAt(i), 10);
              // Posiciones impares (según lectura humana)
              if (i % 2 === 0) {
                  const calculo = (2 * numero).toString();
                  for (let j = 0; j < calculo.length; j++) {
                      sumaImpar += parseInt(calculo.charAt(j), 10);
                  }
              } else {
                  sumaPar += numero;
              }
          }
          const total = sumaPar + sumaImpar;
          const control = (10 - (total % 10)) % 10;
          const digitoControl = identificador.slice(-1);
          const esNumero = !isNaN(parseInt(digitoControl, 10));
  
          return esNumero ? control === parseInt(digitoControl, 10) : digitoControl === serieNumerica.charAt(control);
      } else {
          return false;
      }
  }

  /*
  function esNifNieValido(nifNie) {
      const patronNif = /^[0-9]{8}[A-Z]$/i;
      const patronNie = /^[XYZ][0-9]{7}[A-Z]$/i;
      const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
      
      // Limpiar el NIF/NIE de posibles espacios y convertir a mayúsculas
      nifNie = nifNie.trim().toUpperCase();
      
      // Comprobar si cumple el formato de NIF o NIE
      if (patronNif.test(nifNie)) {
          // Es un NIF
          // Extraer la letra y el número
          const numero = parseInt(nifNie.substring(0, 8));
          const letraCorrecta = letrasValidas.charAt(numero % 23);
          return letraCorrecta === nifNie.charAt(8);
      } else if (patronNie.test(nifNie)) {
          // Es un NIE
          // Convertir la letra inicial en el número correspondiente para la validación
          const numero = parseInt("0" + nifNie.substring(1, 8), 10);
          const letraInicial = nifNie.charAt(0);
          const indiceLetraInicial = letraInicial === 'X' ? 0 : letraInicial === 'Y' ? 1 : 2;
          const letraCorrecta = letrasValidas.charAt((numero + indiceLetraInicial * 10000000) % 23);
          return letraCorrecta === nifNie.charAt(8);
      } else {
          // No cumple el formato de NIF o NIE
          return false;
      }
  }
  */

  
  
  
</script>


<style scoped>

  .page-head2 {
    margin-bottom: 84px !important;
    padding: 0 ;
  }

  .map-card {
    margin: 12px auto;
    width: auto;
  }
  
  .map-card img {
    width: 100%;
    height: auto;
  }
  
  .map-card-text {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 20px;
    margin-left: 20px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: 500;
    color: #4c75d0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Para mejorar la legibilidad del texto */
  }
  
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width:150px !important;
    padding: 0;
  }
  
  ::v-deep .el-select .el-input .el-input__inner {
    color: #484848 !important;
    background-color: white !important;
    border: 1px solid #c0c2ca !important;
  }
  
  ::v-deep .el-select .el-input .el-input__inner::placeholder {
    color: #484848 !important;
  }
  
  ::v-deep .el-select .el-input .el-input__inner::placeholder {
    color: #484848 !important;
  }
  
  ::v-deep .el-select .el-input .el-select::caret {
    color: #484848 !important;
  }
  

   
/* Para pantallas menores o iguales a 600px (ejemplo: móviles) */
@media only screen and (max-width:600px){

  .map-card {
    width: 95vw !important;
    max-width: 98vw;
    margin: 12px auto;
  }

  .textoCalculadora{
    font-size: 1.1em !important;
  }

	.header_menu {
		margin-bottom: 40px;
		background-color: white;
		color: black;
		height: 100px;
		display: flex;
		justify-content: space-between;
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    flex-wrap: wrap;
	}

	.header_menu img{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.header_menu a{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin-right: 4em;
    text-decoration: none;
    color: inherit;
    font-size: 1.2rem;
	}

	.step-container {
		display: flex;
		justify-content: center;
		gap: 50px;
		flex-wrap: wrap;
		padding: 20px;
		font-size: 1.2rem;
		margin-bottom: 3em;
		color: white;
	}

	.elige-top{
		display: flex;
		justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
	}

	.elige-bot{
		display: flex;
		justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-left: 2.8em;
	}

	.elige-bot::after {
		content: "";
		flex: 1 1 calc(25% - 1rem);
		max-width: 25%;
		visibility: hidden;
	}

	.step span{
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.1rem;
	}

	.step-number {
		background-color: #FF6600; /* Naranjito */
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 9px auto;
	}

	.step-title {
		font-weight: bold;
		display: flex;
		justify-content: center;
	}

	.card{
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 20rem;
    height: 21rem;
    border-radius: 2em;
    width: calc(25% - 1rem); /* Cada tarjeta ocupa el 25% del ancho total menos el gap */
    min-width: 200px;
	}

	.card-img-top {
    width: 100%;
    height: 100%;
    border-radius: 2em;
	}	

	.btn {
		background-color: #FF6600 !important;
		color: white;
		width: 95%;
	}

	.btn-top{
		background-color: #FF6600;
		color: white;
    width: 85%;
		display: flex;
		justify-content: center;
		position: absolute !important;
		top: 19em;
		font-weight: bold;
		font-size: 1.3rem;
		border-radius: 10em;
    flex-wrap: wrap;
	}

  .btn:active,
  .btn:focus,
	.btn:hover{
		background-color: white !important;
		color: black;
    border: 2px solid #FF6600;
	}
	
	hr{
		width: 70%;
		background-color: rgb(209, 209, 209);
		text-decoration: none;
		margin: 0 auto;
	}

	.card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    text-align: center;
    flex-wrap: wrap;
	}

	.card-title{
		color: gray;
	}

	.btn-bot{
		width: 70%;
    flex-wrap: wrap;
    border: 2px solid #FF6600 !important;
  }

  .btn-continuar{
    width: auto;
  }

  .icono-aceptado {
    position: absolute;
    width: 30px;
    height: auto;
    right: 20px;
    margin-top: 21.5em;
  }

  .steps-background {
    background-color: #0045c4;
    padding: 20px;
    margin: 20px 0;
    color: white;
    flex-wrap: wrap;
    margin-top: 2em;
  }

::v-deep(.steps-background .el-step__icon) {
  background-color: #0045c4 !important;
  color: white !important;
  border: none !important;
}

::v-deep(.steps-background .el-step__icon.is-process) {
  background-color: #FF6600 !important;
}

::v-deep(.steps-background .el-step__icon.is-finish) {
  background-color: #28a745 !important;
}

::v-deep(.steps-background .el-step__title) {
  color: white !important;
  font-weight: bold;
}

::v-deep(.steps-background .el-step__description) {
  color: white !important;
  font-weight: bold;
}

.el-steps .el-step__title {
    display: none; /* Oculta los títulos para pantallas pequeñas */
  }

.el-steps .el-step__icon {
  font-size: 14px;
}

.icono-aceptado2 {
  position: absolute;
  width: 30px;
  height: auto;
  right: 1em;
  top: 84%;
  margin: 0;
}

.icono-aceptado3 {
  position: absolute;
  width: 30px;
  height: auto;
  right: 40px;
  top: 74%;
  margin: 0;
}

.titulo{
    display: flex;
    justify-content: center;
    font-size: 2.5em;
    margin-top: 1em;
}

}

  /* Para pantallas entre 601px y 1024px (ejemplo: tablets) */
@media (min-width: 601px) and (max-width: 1024px){

  .map-card {
    width: 30em !important;
    height: 20em !important;
    margin: 12px;
  }

	.header_menu {
		margin-bottom: 40px;
		background-color: white;
		color: black;
		height: 100px;
		display: flex;
		justify-content: space-between;
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
	}

	.header_menu img{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 4em;
	}

	.header_menu a{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin-right: 4em;
    text-decoration: none;
    color: inherit;
    font-size: 1.2rem;
	}

	hr{
		width: 90%;
		background-color: rgb(209, 209, 209);
		text-decoration: none;
		margin: 0 auto;
	}

	.step-container {
		display: flex;
		justify-content: center;
		gap: 50px;
		flex-wrap: wrap;
		padding: 20px;
		font-size: 1.2rem;
		margin-bottom: 3em;
	}

	.step {
		max-width: 300px;
	}

	.step span{
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.1rem;
	}

	.step-number {
		background-color: #FF6600; /* Naranjito */
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 9px auto;
	}

	.step-title {
		font-weight: bold;
		display: flex;
		justify-content: center;
	}

	.elige-top{
		display: flex;
		justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
	}

	.elige-bot{
		display: flex;
		justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-left: 2.8em;
	}

	.elige-bot::after {
		content: "";
		flex: 1 1 calc(25% - 1rem);
		max-width: 25%;
		visibility: hidden;
	}

	.card{
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 2em;
	  flex-wrap: wrap;
    width: 25rem;
    height: auto; 
	}

	.card-img-top {
	    width: 100%;
	    height: 100%;
	    border-radius: 2em;
	}	

	.btn {
		background-color: #FF6600 !important;
		color: white;
		width: 95%;
	}

	.btn-top{
		background-color: #FF6600;
		color: white;
    width: 85%;
		display: flex;
		justify-content: center;
		position: absolute !important;
		top: 15.4em;
		font-weight: bold;
		font-size: 1.3rem;
		border-radius: 10em;
    flex-wrap: wrap;
	}

  .btn:active,
  .btn:focus,
	.btn:hover{
		background-color: white !important;
		color: black;
    border: 2px solid #FF6600;
	}

	hr{
		width: 85%;
		background-color: rgb(209, 209, 209);
		text-decoration: none;
		margin: 0 auto;
	}

	.card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    text-align: center;
	}

	.card-title{
		color: gray;
	}

	.btn-bot{
		max-width: 70%;
    border: 2px solid #FF6600 !important;
	}

  .btn-continuar{
    width: auto;
  }

  .icono-aceptado {
    position: absolute;
    width: 30px;
    height: auto;
    right: 5px;
    margin-top: 21.5em;
  }

  .steps-background {
  background-color: #0045c4;
  padding: 20px;
  margin: 20px 0;
  color: white;
  margin-top: 2.2em;
}

::v-deep(.steps-background .el-step__icon) {
  background-color: #0045c4 !important;
  color: white !important;
  border: none !important;
}

::v-deep(.steps-background .el-step__icon.is-process) {
  background-color: #FF6600 !important;
}

::v-deep(.steps-background .el-step__icon.is-finish) {
  background-color: #28a745 !important;
}

::v-deep(.steps-background .el-step__title) {
  color: white !important;
  font-weight: bold;
}

::v-deep(.steps-background .el-step__description) {
  color: white !important;
  font-weight: bold;
}

.icono-aceptado2 {
  position: absolute;
  width: 30px;
  height: auto;
  right: 15px;
  top: 85%;
  margin: 0;
}

.icono-aceptado3 {
  position: absolute;
  width: 30px;
  height: auto;
  right: 15px;
  top: 75%;
  margin: 0;
}

.titulo{
    display: flex;
    justify-content: center;
    font-size: 1.5em;
    margin-top: 1em;
  }

}

  @media (min-width: 1025px) and (max-width: 1674px){

	.header_menu {
		margin-bottom: 40px;
		background-color: white;
		color: black;
		height: 100px;
		display: flex;
		justify-content: space-between;
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
	}

	.step-container {
		display: flex;
		justify-content: center;
		gap: 50px;
		flex-wrap: wrap;
		padding: 20px;
		font-size: 1.5rem;
		margin-bottom: 3em;
	}

	.step {
		max-width: 300px;
		color: white;
	}

	.step span{
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.1rem;
    color: white;
	}

	.step-number {
		background-color: #FF6600; /* Naranjito */
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 9px auto;
	}

	.step-title {
		font-weight: bold;
		display: flex;
		justify-content: center;
	}

	.elige-top{
		display: flex;
		justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
	}

	.elige-bot{
		display: flex;
		justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-left: 4em;
	}

	.elige-bot::after {
		content: "";
		flex: 1 1 calc(25% - 1rem);
		max-width: 25%;
		visibility: hidden;
	}

	.card{
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 20rem;
    height: 21rem;
    border-radius: 2em;
		flex-wrap: wrap;
	}

	.card-img-top {
    width: 100%;
    height: 100%;
    border-radius: 2em;
	}	

	.btn {
		background-color: #FF6600 !important;
		color: white;
		width: 95%;
	}

	.btn-top{
		background-color: #FF6600;
		color: white;
		width: 85%;
		display: flex;
		justify-content: center;
		position: absolute !important;
		top: 19em;
		font-weight: bold;
		font-size: 1.3rem;
		border-radius: 10em;
	}

  .btn:active,
  .btn:focus,
	.btn:hover{
		background-color: white !important;
		color: black;
    border: 2px solid #FF6600;
	}

	hr{
		width: 90%;
		background-color: rgb(209, 209, 209);
		text-decoration: none;
		margin: 0 auto;
	}

	.card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80%;
    text-align: center;
	}
	
	.btn-bot{
		max-width: 50%;
    border: 2px solid #FF6600 !important;
	}

  .btn-continuar{
    background-color: #FF6600;
    max-width: auto;
  }

  .icono-aceptado {
    position: absolute;
    width: 30px;
    height: auto;
    right: 20px;
    margin-top: 21.5em;
  }

  .steps-background {
    background-color: #0045c4;
    padding: 20px;
    margin: 20px 0;
    color: white;
    margin-top: 2.2em;
  }

  ::v-deep(.steps-background .el-step__icon) {
    background-color: #0045c4 !important;
    color: white !important;
    border: none !important;
  }

  ::v-deep(.steps-background .el-step__icon.is-process) {
    background-color: #FF6600 !important;
  }

  ::v-deep(.steps-background .el-step__icon.is-finish) {
    background-color: #28a745 !important;
  }

  ::v-deep(.steps-background .el-step__title) {
    color: white !important;
    font-weight: bold;
  }

  ::v-deep(.steps-background .el-step__description) {
    color: white !important;
    font-weight: bold;
  }

  .icono-aceptado2 {
    position: absolute;
    width: 30px;
    height: auto;
    right: 40px;
    top: 85%;
    margin: 0;
  }

  .icono-aceptado3 {
    position: absolute;
    width: 30px;
    height: auto;
    right: 100px;
    top: 75%;
    margin: 0;
  }

  .titulo{
    display: flex;
    justify-content: center;
    font-size: 1.5em;
    margin-top: 1em;
  }

}    

/* Para pantallas mayores a 1675px (ejemplo: computadoras) */
@media only screen and (min-width: 1675px){

	.header_menu {
		margin-bottom: 40px;
		background-color: white;
		color: black;
		height: 100px;
		display: flex;
		justify-content: space-between;
		box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
	}

	.step-container {
		display: flex;
		justify-content: center;
		gap: 50px;
		flex-wrap: wrap;
		padding: 20px;
		font-size: 1.5rem;
		margin-bottom: 3em;
	}

	.step {
		max-width: 300px;
		color: white;
	}

	.step span{
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.1rem;
    color: white;
	}

	.step-number {
		background-color: #FF6600; /*Naranjito*/
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 9px auto;
	}

	.step-title {
		font-weight: bold;
		display: flex;
		justify-content: center;
	}

	.card{
		box-shadow: 10px 10px 15px 10px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 21rem;
    height: 21rem;
    border-radius: 2em;
	}

	.card-img-top {
    width: 100%;
    height: 100%;
    border-radius: 2em;
	}	

	.btn {
		background-color: #FF6600 !important;
		color: white;
		width: 95%;
	}

	.btn-top{
		background-color: #FF6600;
		color: white;
		width: 85%;
		display: flex;
		justify-content: center;
		position: absolute !important;
		top: 17rem;
		font-weight: bold;
		font-size: 1.3rem;
		border-radius: 10em;
	}

  .btn:active,
  .btn:focus,
	.btn:hover{
		background-color: white !important;
		color: black;
    border: 2px solid #FF6600;
	}

	.card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80%;
    text-align: center;
	}

	.btn-bot{
		max-width: 50%;
    border: 2px solid #FF6600 !important;
	}

  .btn-continuar{
    max-width: 10%;
  }

  .icono-aceptado {
    position: absolute;
    width: 30px;
    height: auto;
    right: 20px;
    margin-top: 21.5em;
  }

  .steps-background {
    background-color: #0045c4;
    padding: 20px;
    margin: 20px 0;
    color: white;
    box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    margin-top: 2em;
  }

  ::v-deep(.steps-background .el-step__icon) {
    background-color: #0045c4 !important;
    color: white !important;
    border: none !important;
  }

  ::v-deep(.steps-background .el-step__icon.is-process) {
    background-color: #FF6600 !important;
  }

  ::v-deep(.steps-background .el-step__icon.is-finish) {
    background-color: #28a745 !important;
  }

  ::v-deep(.steps-background .el-step__title) {
    color: white !important;
    font-weight: bold;
  }

  ::v-deep(.steps-background .el-step__description) {
    color: white !important;
    font-weight: bold;
  }

  .icono-aceptado2 {
    position: absolute;
    width: 30px;
    height: auto;
    right: 23%;
    top: 84%;
    margin: 0;
  }

  .icono-aceptado3 {
    position: absolute;
    width: 30px;
    height: auto;
    right: 110px;
    top: 71%;
    margin: 0;
  }

  .titulo{
    display: flex;
    justify-content: center;
    font-size: 1.5em;
    margin-top: 1em;
  }

}


.wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
}

.btn-seleccionado {
  background-color: white !important;
  color: black !important;
  border: 2px solid #FF6600 !important;
}

.img-seleccionado{

  border: 2px solid rgb(131, 131, 131) !important;
  opacity: 100% !important;
}

.card-container {
  margin: 0 auto;
}

.card-wrapper {
  flex: 1 1 calc(33.333% - 20px); /* 3 tarjetas por fila con espacio entre ellas */
  max-width: calc(33.333% - 20px);
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .card-wrapper {
    flex: 1 1 calc(50% - 20px); /* 2 tarjetas por fila en pantallas medianas */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 480px) {
  .card-wrapper {
    flex: 1 1 100%; /* 1 tarjeta por fila en pantallas pequeñas */
    max-width: 100%;
  }
}

</style>
